import defaultConfig from './defaultConfig.js'
export default {
	namespaced: true,
	state: {

		//左侧栏设备基本控件默认配置
		defaultBasicConfig: defaultConfig.defaultBasicConfig,

		//左侧栏所有设备信息
		defaultDeviceConfig: defaultConfig.defaultDeviceConfig,

		//当前索引值
		currentIndex: 0,

		// ImageBaseUrl: 'http://iot.yonjie.com', //永捷服务器
		ImageBaseUrl: window.location.protocol+'//'+window.location.hostname,//图片地址 打包
		// ImageBaseUrl: 'http://192.168.3.12',//本地

    // 6.23 添加2d接头   id为24-31
		adapter: [{
			id: -1,
			url: '',
			allowType: [{
				name: 'conduit30',
				type: ['N', 'F']
			}, {
				name: 'conduit-30',
				type: ['N', 'F']
			}, {
				name: 'conduit90',
				type: ['N', 'F']
			}, {
				name: 'conduit90_2d',
				type: ['N', 'F']
			}, {
				name: 'conduit0',
				type: ['N', 'F']
			}]
		}, {
			id: 0,
			url: require('@/assets/image/editor/Device/0.png'),
			allowType: [{
				name: 'conduit30',
				type: ['N']
			}, {
				name: 'conduit-30',
				type: ['N']
			}]
		}, {
			id: 1,
			url: require('@/assets/image/editor/Device/1.png'),
			allowType: [{
				name: 'conduit-30',
				type: ['F'],
			}]
		}, {
			id: 2,
			url: require('@/assets/image/editor/Device/2.png'),
			allowType: [{
				name: 'conduit90',
				type: ['F'],
			}, {
				name: 'conduit-30',
				type: ['F'],
			}]
		}, {
			id: 3,
			url: require('@/assets/image/editor/Device/3.png'),
			allowType: [{
				name: 'conduit90',
				type: ['F'],
			}, {
				name: 'conduit-30',
				type: ['N'],
			}]
		}, {
			id: 4,
			url: require('@/assets/image/editor/Device/4.png'),
			allowType: [{
				name: 'conduit30',
				type: ['F'],
			}, {
				name: 'conduit-30',
				type: ['F'],
			}]
		}, {
			id: 5,
			url: require('@/assets/image/editor/Device/5.png'),
			allowType: [{
				name: 'conduit90',
				type: ['F'],
			}]
		}, {
			id: 6,
			url: require('@/assets/image/editor/Device/6.png'),
			allowType: [{
				name: 'conduit30',
				type: ['F'],
			}, {
				name: 'conduit-30',
				type: ['N'],
			}]
		}, {
			id: 7,
			url: require('@/assets/image/editor/Device/7.png'),
			allowType: [{
				name: 'conduit-30',
				type: ['N'],
			}]
		}, {
			id: 8,
			url: require('@/assets/image/editor/Device/8.png'),
			allowType: [{
				name: 'conduit30',
				type: ['N'],
			}, {
				name: 'conduit-30',
				type: ['F'],
			}]
		}, {
			id: 9,
			url: require('@/assets/image/editor/Device/9.png'),
			allowType: [{
				name: 'conduit30',
				type: ['N'],
			}]
		}, {
			id: 10,
			url: require('@/assets/image/editor/Device/10.png'),
			allowType: [{
				name: 'conduit30',
				type: ['F'],
			}, {
				name: 'conduit90',
				type: ['N'],
			}]
		}, {
			id: 11,
			url: require('@/assets/image/editor/Device/11.png'),
			allowType: [{
				name: 'conduit-30',
				type: ['N'],
			}]
		}, {
			id: 12,
			url: require('@/assets/image/editor/Device/12.png'),
			allowType: [{
				name: 'conduit30',
				type: ['F'],
			}]
		}, {
			id: 13,
			url: require('@/assets/image/editor/Device/13.png'),
			allowType: [{
				name: 'conduit-30',
				type: ['F'],
			}]
		}, {
			id: 14,
			url: require('@/assets/image/editor/Device/14.png'),
			allowType: [{
				name: 'conduit30',
				type: ['N'],
			}]
		}, {
			id: 15,
			url: require('@/assets/image/editor/Device/15.png'),
			allowType: [{
				name: 'conduit-30',
				type: ['F'],
			}, {
				name: 'conduit90',
				type: ['N'],
			}]
		}, {
			id: 16,
			url: require('@/assets/image/editor/Device/16.png'),
			allowType: [{
				name: 'conduit-30',
				type: ['N'],
			}, {
				name: 'conduit90',
				type: ['N'],
			}]
		}, {
			id: 17,
			url: require('@/assets/image/editor/Device/17.png'),
			allowType: [{
				name: 'conduit90',
				type: ['N'],
			}]
		}, {
			id: 18,
			url: require('@/assets/image/editor/Device/18.png'),
			allowType: [{
				name: 'conduit30',
				type: ['F'],
			}]
		}, {
			id: 19,
			url: require('@/assets/image/editor/Device/19.png'),
			allowType: [{
				name: 'conduit90',
				type: ['F'],
			}, {
				name: 'conduit30',
				type: ['F'],
			}]
		}, {
			id: 20,
			url: require('@/assets/image/editor/Device/20.png'),
			allowType: [{
				name: 'conduit90',
				type: ['N'],
			}]
		}, {
			id: 21,
			url: require('@/assets/image/editor/Device/21.png'),
			allowType: [{
				name: 'conduit90',
				type: ['F'],
			}]
		}, {
			id: 22,
			url: require('@/assets/image/editor/Device/22.png'),
			allowType: [{
				name: 'conduit90',
				type: ['F'],
			}, {
				name: 'conduit30',
				type: ['N'],
			}]
		}, {
			id: 23,
			url: require('@/assets/image/editor/Device/23.png'),
			allowType: [{
				name: 'conduit90',
				type: ['N'],
			}, {
				name: 'conduit30',
				type: ['N'],
			}]
		}, {
			id: 24,
			url: require('@/assets/image/editor/Device/24.png'),
			allowType: [{
				name: 'conduit0',
				type: ['N'],
			}, {
				name: 'conduit90_2d',
				type: ['F'],
			}]
		}, {
			id: 25,
			url: require('@/assets/image/editor/Device/25.png'),
			allowType: [{
				name: 'conduit0',
				type: ['F'],
			}, {
				name: 'conduit90_2d',
				type: ['F'],
			}]
		}, {
			id: 26,
			url: require('@/assets/image/editor/Device/26.png'),
			allowType: [{
				name: 'conduit0',
				type: ['F'],
			}, {
				name: 'conduit90_2d',
				type: ['N'],
			}]
		}, {
			id: 27,
			url: require('@/assets/image/editor/Device/27.png'),
			allowType: [{
				name: 'conduit0',
				type: ['N'],
			}, {
				name: 'conduit90_2d',
				type: ['N'],
			}]
		}, {
			id: 28,
			url: require('@/assets/image/editor/Device/28.png'),
			allowType: [{
				name: 'conduit0',
				type: ['F'],
			}, {
				name: 'conduit90_2d',
				type: ['N','F'],
			}]
		}, {
			id: 29,
			url: require('@/assets/image/editor/Device/29.png'),
			allowType: [{
				name: 'conduit0',
				type: ['N','F'],
			}, {
				name: 'conduit90_2d',
				type: ['N'],
			}]
		}, {
			id: 30,
			url: require('@/assets/image/editor/Device/30.png'),
			allowType: [{
				name: 'conduit0',
				type: ['N'],
			}, {
				name: 'conduit90_2d',
				type: ['N','F'],
			}]
		}, {
			id: 31,
			url: require('@/assets/image/editor/Device/31.png'),
			allowType: [{
				name: 'conduit0',
				type: ['N','F'],
			}, {
				name: 'conduit90_2d',
				type: ['F'],
			}]
		}],
		//zIndex中间值
		zIndex: 1,
		zIndexPass: 1,
		zIndexMin: 0,
		zIndexMax: 0,

		//画布里所有图表
		draggable: [],

		//存放撤销状态总数组
		revokeDraggable: [],
		//存放撤销步数
		revokeNum: 50,
		//存放恢复状态总数组
		recoverDraggable: [],
		//存放恢复步数
		recoverNum: 50,

		//存放当前操作步数
		step: 0,

		//缩放等级
		scaleLevel: 1,

		//索引开始值
		index: 1,

		//x轴,y轴 对齐幅值
		amplitudeX: 10,
		amplitudeY: -81.5,

		//连接点显示 设置间距
		ConnectPointMargin: 100,

		//连接点自动附着 设置间距
		ConnectPointAttachMargin: 8,

		//显示斜对齐线的差值
		SkewAlineAmplitude: 0.025,

		//Ctrl是否按住
		sync: false,

		//展示转接头列表
		ShowMarkNear: false,
		ShowMarkFar: false,

		//当前地图偏移量
		editorLeft: 0,
		editorTop: 0,

		//存放当前编辑器左侧设备控件列表 用于更新旧版本的控件的连接点及斜对齐线
		mothFather: [],

		//存放当前index上提示的版本信息
		MapType: '',
		MapName: '',
    // 地图背景设置
    MapBgData:{
      bgColor:""
    },

		//用于判断当前属性名称输入框是否获取焦点
		inputFocus: false,
	},
	getters: {

		//		this.getters['defaultImgOptions/calculateRotate']({x:61,y:100},30)
		calculateRotate: (state, getters) => (ConnectPoint, degree, width) => {
			if(degree == 30 || degree == 0 || degree == -30) {
				let x = ConnectPoint.x * Math.cos(degree * Math.PI / 180) + ConnectPoint.y * Math.sin(degree * Math.PI / 180);
				let y = -ConnectPoint.x * Math.sin(degree * Math.PI / 180) + ConnectPoint.y * Math.cos(degree * Math.PI / 180);
				let relativeOriginPoint = {
					x: Math.round(x * 100) / 100,
					y: Math.round(y * 100) / 100
				};
				return relativeOriginPoint;
			} else if(degree == 90) {
				return ConnectPoint;
			}

		},
		getScaleLevel(state) {
			return state.scaleLevel;
		},
	},
	mutations: {
		inputFocusChange(state, obj) {
			state.inputFocus = !state.inputFocus;
		},
		AllChoice(state, obj) {
			state.currentIndex = 0;
			for(let drag of state.draggable) {
				if(drag.ShowActive) {
					drag.active = true;
					drag.NowActive = false;
					drag.ConnectMark = false;
				}
			}
		},
		MapUpdata(state, obj) {
			state.MapType = obj.type;
			state.MapName = obj.name;
		},
		editorLeftClear(state, val) {
			state.editorLeft = 0;
		},
		editorTopClear(state, val) {
			state.editorTop = 0;
		},
		editorLeftUpdata(state, val) {
			state.editorLeft = val;
		},
		editorTopUpdata(state, val) {
			state.editorTop = val;
		},
		keyCodeDirection(state, keyCodeArry) {
			for(var i = 0; i < keyCodeArry.length; i++) {
				for(var a = 0; a < state.draggable.length; a++) {
					if(keyCodeArry[i] === 37) {
						//左键
						if(state.draggable[a].active) {
							state.draggable[a].x -= 1;
							state.draggable[a].centerPointX -= 1;
						}
					} else if(keyCodeArry[i] === 38) {
						//上键
						if(state.draggable[a].active) {
							state.draggable[a].y -= 1;
							state.draggable[a].centerPointY -= 1;
						}
					} else if(keyCodeArry[i] === 39) {
						//右键
						if(state.draggable[a].active) {
							state.draggable[a].x += 1;
							state.draggable[a].centerPointX += 1;
						}
					} else if(keyCodeArry[i] === 40) {
						//下键
						if(state.draggable[a].active) {
							state.draggable[a].y += 1;
							state.draggable[a].centerPointY += 1;
						}
					}
				}
			}
		},
		//隐藏斜对齐线 设备
		SkewAlignmentEquipmentClose(state, index) {
			for(var a = 0; a < state.draggable.length; a++) {
				for(var i = 0; i < state.draggable[a].SkewAline.length; i++) {
					state.draggable[a].SkewAline[i].Mark = false;
				}
			}
		},

		//显示设备斜对齐线
		SkewAlignmentEquipmentShow(state, index) {

			//开根号
			function sqrtOpen(m) {
				if(1 === m) return 1;
				if(0 === m) return 0;
				if(m < 0) return NaN;
				var s = m / 2;
				var last;
				while(last != s) {
					last = s;
					s = 1 / 2 * (s + m / s)
				}
				return s;
			}

			var ThisActive = state.draggable.filter(item => item.index == index)[0];
			if(ThisActive.type != 'img') return;
			var OtherDraggable = state.draggable.filter(item => item.index != index && item.ShowActive);
			for(var i = 0; i < OtherDraggable.length; i++) {
				for(var v = 0; v < OtherDraggable[i].SkewAline.length; v++) {

					if(OtherDraggable[i].SkewAline[v].name == 'LeftTop_vm') {
						/*
						 * 左上角去左下方 A
						 */
						if(OtherDraggable[i].x > ThisActive.x && OtherDraggable[i].y < ThisActive.y) {
							var x = Math.round(OtherDraggable[i].x / sqrtOpen(3));
							var ab = x;
							var bc = 2 * x;
							var bd = ab + OtherDraggable[i].y; // b点(0,bd); (x1,y1)
							var de = Math.round(bd * sqrtOpen(3)); // e点(de,0); (x2,y2)

							var distance_ab = ThisActive.y - OtherDraggable[i].y;
							var distance_ac = OtherDraggable[i].x - ThisActive.x;
							var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
							var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));
							/*
							 * 斜率公式  k = (y2 - y1) / (x2 - x1)
							 */
							/*
							 * 直线方程 (x-x1)/(x2-x1)=(y-y1)/(y2-y1)
							 */
							//var OtherDraggableSlope = ( 0 - bd) / ( de - 0);//OtherDraggable[i]斜率
							//var ThisActiveSlope = ThisActive.height / ThisActive.width;//ThisActive斜率
							/*
							 * 判断ThisActive的(x,y)是否在该直线方程上
							 */
							if(Math.floor(ThisActive.x / de * 100) / 100 >= (Math.floor((ThisActive.y - bd) / (-bd) * 100) / 100) - state.SkewAlineAmplitude && Math.floor(ThisActive.x / de * 100) / 100 <= (Math.floor((ThisActive.y - bd) / (-bd) * 100) / 100) + state.SkewAlineAmplitude && bd != 0) {
								//								state.draggable[a].x = parseInt((ThisActive.y - bd) / (-bd) * de);
								//								state.draggable[a].y = parseInt((ThisActive.x / de * (-bd)) + bd);
								OtherDraggable[i].SkewAline[v].Mark = true;
								OtherDraggable[i].SkewAline[v].width = distance_cb;
							} else if(OtherDraggable[i].SkewAline[v].Mark) {
								OtherDraggable[i].SkewAline[v].Mark = false;
								OtherDraggable[i].SkewAline[v].width = 0;
							}

						} else {
							OtherDraggable[i].SkewAline[v].Mark = false;
							OtherDraggable[i].SkewAline[v].width = 0;
						}
					} else if(OtherDraggable[i].SkewAline[v].name == 'LeftTop') {
						/*
						 * 左上角去右上方 A
						 */
						if(ThisActive.x > OtherDraggable[i].x && ThisActive.y < OtherDraggable[i].y) {
							var x = Math.round(OtherDraggable[i].x / sqrtOpen(3));
							var ab = x;
							var bd = ab + OtherDraggable[i].y; // b点(0,bd); (x1,y1)
							var de = Math.round(bd * sqrtOpen(3)); // e点(de,0); (x2,y2)

							var distance_ab = ThisActive.y - OtherDraggable[i].y;
							var distance_ac = OtherDraggable[i].x - ThisActive.x;
							var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
							var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));
							if(Math.floor(ThisActive.x / de * 100) / 100 >= (Math.floor((ThisActive.y - bd) / (-bd) * 100) / 100) - state.SkewAlineAmplitude && Math.floor(ThisActive.x / de * 100) / 100 <= (Math.floor((ThisActive.y - bd) / (-bd) * 100) / 100) + state.SkewAlineAmplitude && bd != 0) {
								//								state.draggable[a].x = parseInt((ThisActive.y - bd) / (-bd) * de);
								//								state.draggable[a].y = parseInt((ThisActive.x / de * (-bd)) + bd);
								OtherDraggable[i].SkewAline[v].Mark = true;
								OtherDraggable[i].SkewAline[v].width = distance_cb;
							} else if(OtherDraggable[i].SkewAline[v].Mark) {
								OtherDraggable[i].SkewAline[v].Mark = false;
								OtherDraggable[i].SkewAline[v].width = 0;
							}
						} else {
							OtherDraggable[i].SkewAline[v].Mark = false;
							OtherDraggable[i].SkewAline[v].width = 0;
						}
					} else if(OtherDraggable[i].SkewAline[v].name == 'RightBottom') {
						/*
						 * 右下角去左下方 D
						 */
						if(OtherDraggable[i].y + OtherDraggable[i].height < ThisActive.y + ThisActive.height && OtherDraggable[i].x + OtherDraggable[i].width > ThisActive.x + ThisActive.width) {
							var x = Math.round((OtherDraggable[i].x + OtherDraggable[i].width) / sqrtOpen(3));
							var ab = x;
							var bd = ab + OtherDraggable[i].height + OtherDraggable[i].y; // b点(0,bd); (x1,y1)
							var de = Math.round(bd * sqrtOpen(3)); // e点(de,0); (x2,y2)

							var distance_ab = (ThisActive.y + ThisActive.height) - (OtherDraggable[i].y + OtherDraggable[i].height);
							var distance_ac = (OtherDraggable[i].x + OtherDraggable[i].width) - (ThisActive.x + ThisActive.width);
							var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
							var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));

							if(Math.floor(((ThisActive.x + ThisActive.width) - 0) / (de - 0) * 100) / 100 >= (Math.floor((ThisActive.y + ThisActive.height - bd) / (0 - bd) * 100) / 100) - state.SkewAlineAmplitude && Math.floor(((ThisActive.x + ThisActive.width) - 0) / (de - 0) * 100) / 100 <= (Math.floor((ThisActive.y + ThisActive.height - bd) / (0 - bd) * 100) / 100) + state.SkewAlineAmplitude && bd != 0) {
								//								state.draggable[a].x = parseInt(((ThisActive.y + ThisActive.height - bd) / (-bd) * de) - ThisActive.width);
								//								state.draggable[a].y = parseInt((((ThisActive.x + ThisActive.width) / de * (-bd)) + bd) - ThisActive.height);
								OtherDraggable[i].SkewAline[v].Mark = true;
								OtherDraggable[i].SkewAline[v].width = distance_cb;
							} else if(OtherDraggable[i].SkewAline[v].Mark) {
								OtherDraggable[i].SkewAline[v].Mark = false;
								OtherDraggable[i].SkewAline[v].width = 0;
							}
						} else {
							OtherDraggable[i].SkewAline[v].Mark = false;
							OtherDraggable[i].SkewAline[v].width = 0;
						}
					} else if(OtherDraggable[i].SkewAline[v].name == 'RightBottom_vm') {
						/*
						 * 右上角去右上方 D
						 */
						if(ThisActive.x > OtherDraggable[i].x + OtherDraggable[i].width && OtherDraggable[i].y + OtherDraggable[i].height > ThisActive.y + ThisActive.height) {
							var x = Math.round((OtherDraggable[i].x + OtherDraggable[i].width) / sqrtOpen(3));
							var ab = x;
							var bd = ab + OtherDraggable[i].height + OtherDraggable[i].y; // b点(0,bd); (x1,y1)
							var de = Math.round(bd * sqrtOpen(3)); // e点(de,0); (x2,y2)

							var distance_ab = (ThisActive.y + ThisActive.height) - (OtherDraggable[i].y + OtherDraggable[i].height);
							var distance_ac = (OtherDraggable[i].x + OtherDraggable[i].width) - (ThisActive.x + ThisActive.width);
							var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
							var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));

							if(Math.floor(((ThisActive.x + ThisActive.width) - 0) / (de - 0) * 100) / 100 >= (Math.floor((ThisActive.y + ThisActive.height - bd) / (0 - bd) * 100) / 100) - state.SkewAlineAmplitude && Math.floor(((ThisActive.x + ThisActive.width) - 0) / (de - 0) * 100) / 100 <= (Math.floor((ThisActive.y + ThisActive.height - bd) / (0 - bd) * 100) / 100) + state.SkewAlineAmplitude && bd != 0) {
								//								state.draggable[a].x = parseInt(((ThisActive.y + ThisActive.height - bd) / (-bd) * de) - ThisActive.width);
								//								state.draggable[a].y = parseInt((((ThisActive.x + ThisActive.width) / de * (-bd)) + bd) - ThisActive.height);
								OtherDraggable[i].SkewAline[v].Mark = true;
								OtherDraggable[i].SkewAline[v].width = distance_cb;
							} else if(OtherDraggable[i].SkewAline[v].Mark) {
								OtherDraggable[i].SkewAline[v].Mark = false;
								OtherDraggable[i].SkewAline[v].width = 0;
							}
						} else {
							OtherDraggable[i].SkewAline[v].Mark = false;
							OtherDraggable[i].SkewAline[v].width = 0;
						}
					} else if(OtherDraggable[i].SkewAline[v].name == 'RightTop') {
						/*
						 * 右上角去右下方 C
						 */
						if(ThisActive.y > OtherDraggable[i].y && ThisActive.x + ThisActive.width > OtherDraggable[i].x + OtherDraggable[i].width) {
							var x = OtherDraggable[i].y;
							var ef = Math.round(x * sqrtOpen(3));
							var ePoint = -(ef - (OtherDraggable[i].x + OtherDraggable[i].width))
							// e点(ePoint,0); (x1,y1)
							// c点(OtherDraggable[i].x+OtherDraggable[i].width, OtherDraggable[i].y); (x2,y2)

							var distance_ab = ThisActive.y - OtherDraggable[i].y;
							var distance_ac = (ThisActive.x + ThisActive.width) - (OtherDraggable[i].x + OtherDraggable[i].width);
							var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
							var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));

							var vm_x = ThisActive.x + ThisActive.width;
							var vm_x1 = ePoint;
							var vm_x2 = OtherDraggable[i].x + OtherDraggable[i].width;
							var vm_y = ThisActive.y;
							var vm_y1 = 0;
							var vm_y2 = OtherDraggable[i].y;
							if(Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 >= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) - state.SkewAlineAmplitude && Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 <= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) + state.SkewAlineAmplitude && vm_y2 != 0) {
								OtherDraggable[i].SkewAline[v].Mark = true;
								OtherDraggable[i].SkewAline[v].width = distance_cb;
							} else if(OtherDraggable[i].SkewAline[v].Mark) {
								OtherDraggable[i].SkewAline[v].Mark = false;
								OtherDraggable[i].SkewAline[v].width = 0;
							}
						} else {
							OtherDraggable[i].SkewAline[v].Mark = false;
							OtherDraggable[i].SkewAline[v].width = 0;
						}
					} else if(OtherDraggable[i].SkewAline[v].name == 'RightTop_vm') {
						/*
						 * 右上角去左上方 C
						 */
						if(ThisActive.y < OtherDraggable[i].y && ThisActive.x + ThisActive.width < OtherDraggable[i].x + OtherDraggable[i].width) {
							var x = OtherDraggable[i].y;
							var ef = Math.round(x * sqrtOpen(3));
							var ePoint = -(ef - (OtherDraggable[i].x + OtherDraggable[i].width))
							// e点(ePoint,0); (x1,y1)
							// c点(OtherDraggable[i].x+OtherDraggable[i].width, OtherDraggable[i].y); (x2,y2)

							var distance_ab = ThisActive.y - OtherDraggable[i].y;
							var distance_ac = (ThisActive.x + ThisActive.width) - (OtherDraggable[i].x + OtherDraggable[i].width);
							var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
							var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));

							var vm_x = ThisActive.x + ThisActive.width;
							var vm_x1 = ePoint;
							var vm_x2 = OtherDraggable[i].x + OtherDraggable[i].width;
							var vm_y = ThisActive.y;
							var vm_y1 = 0;
							var vm_y2 = OtherDraggable[i].y;
							if(Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 >= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) - state.SkewAlineAmplitude && Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 <= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) + state.SkewAlineAmplitude && vm_y2 != 0) {
								OtherDraggable[i].SkewAline[v].Mark = true;
								OtherDraggable[i].SkewAline[v].width = distance_cb;
							} else if(OtherDraggable[i].SkewAline[v].Mark) {
								OtherDraggable[i].SkewAline[v].Mark = false;
								OtherDraggable[i].SkewAline[v].width = 0;
							}
						} else {
							OtherDraggable[i].SkewAline[v].Mark = false;
							OtherDraggable[i].SkewAline[v].width = 0;
						}
					} else if(OtherDraggable[i].SkewAline[v].name == 'LeftBottom') {
						/*
						 * 左下角去左上方 B
						 */
						if(ThisActive.y < OtherDraggable[i].y && ThisActive.x < OtherDraggable[i].x) {
							var x = OtherDraggable[i].y + OtherDraggable[i].height;
							var ef = Math.round(x * sqrtOpen(3));
							var ePoint = -(ef - OtherDraggable[i].x)
							// e点(ePoint,0); (x1,y1)
							// c点(OtherDraggable[i].x, OtherDraggable[i].y+OtherDraggable[i].height); (x2,y2)

							var distance_ab = (ThisActive.y + ThisActive.height) - (OtherDraggable[i].y + OtherDraggable[i].height);
							var distance_ac = ThisActive.x - OtherDraggable[i].x;
							var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
							var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));

							var vm_x = ThisActive.x;
							var vm_x1 = ePoint;
							var vm_x2 = OtherDraggable[i].x;
							var vm_y = ThisActive.y + ThisActive.height;
							var vm_y1 = 0;
							var vm_y2 = OtherDraggable[i].y + OtherDraggable[i].height;
							if(Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 >= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) - state.SkewAlineAmplitude && Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 <= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) + state.SkewAlineAmplitude && vm_y2 != 0) {
								OtherDraggable[i].SkewAline[v].Mark = true;
								OtherDraggable[i].SkewAline[v].width = distance_cb;
							} else if(OtherDraggable[i].SkewAline[v].Mark) {
								OtherDraggable[i].SkewAline[v].Mark = false;
								OtherDraggable[i].SkewAline[v].width = 0;
							}
						} else {
							OtherDraggable[i].SkewAline[v].Mark = false;
							OtherDraggable[i].SkewAline[v].width = 0;
						}
					} else if(OtherDraggable[i].SkewAline[v].name == 'LeftBottom_vm') {
						/*
						 * 左下角去右下方 B
						 */
						if(ThisActive.y > OtherDraggable[i].y && ThisActive.x > OtherDraggable[i].x) {
							var x = OtherDraggable[i].y + OtherDraggable[i].height;
							var ef = Math.round(x * sqrtOpen(3));
							var ePoint = -(ef - OtherDraggable[i].x)
							// e点(ePoint,0); (x1,y1)
							// c点(OtherDraggable[i].x, OtherDraggable[i].y+OtherDraggable[i].height); (x2,y2)

							var distance_ab = (ThisActive.y + ThisActive.height) - (OtherDraggable[i].y + OtherDraggable[i].height);
							var distance_ac = ThisActive.x - OtherDraggable[i].x;
							var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
							var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));

							var vm_x = ThisActive.x;
							var vm_x1 = ePoint;
							var vm_x2 = OtherDraggable[i].x;
							var vm_y = ThisActive.y + ThisActive.height;
							var vm_y1 = 0;
							var vm_y2 = OtherDraggable[i].y + OtherDraggable[i].height;
							if(Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 >= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) - state.SkewAlineAmplitude && Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 <= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) + state.SkewAlineAmplitude && vm_y2 != 0) {
								OtherDraggable[i].SkewAline[v].Mark = true;
								OtherDraggable[i].SkewAline[v].width = distance_cb;
							} else if(OtherDraggable[i].SkewAline[v].Mark) {
								OtherDraggable[i].SkewAline[v].Mark = false;
								OtherDraggable[i].SkewAline[v].width = 0;
							}
						} else {
							OtherDraggable[i].SkewAline[v].Mark = false;
							OtherDraggable[i].SkewAline[v].width = 0;
						}
					}
				}
			}
		},

		//隐藏斜对齐线
		SkewAlignmentClose(state, index) {
			for(var a = 0; a < state.draggable.length; a++) {
				for(var m = 0; m < state.draggable[a].ConnectPoint.length; m++) {
					for(var i = 0; i < state.draggable[a].ConnectPoint[m].SkewAline.length; i++) {
						state.draggable[a].ConnectPoint[m].SkewAline[i].Mark = false;
					}
				}

			}
		},

		//显示斜对齐线
		SkewAlignmentShow(state, index) {

			//开根号
			function sqrtOpen(m) {
				if(1 === m) return 1;
				if(0 === m) return 0;
				if(m < 0) return NaN;
				var s = m / 2;
				var last;
				while(last != s) {
					last = s;
					s = 1 / 2 * (s + m / s)
				}
				return s;
			}

			function MathFloor(num) {
				return Math.floor(num * 100) / 100;
			}
			var ThisActive = state.draggable.filter(item => item.index == index)[0];
			var OtherDraggable = state.draggable.filter(item => item.index != index && item.ShowActive);
			for(var i = 0; i < OtherDraggable.length; i++) {
				for(var n = 0; n < ThisActive.ConnectPoint.length; n++) { //判断选中的有多少个连接点
					if(ThisActive.ConnectPoint[n].Mark) {
						for(var m = 0; m < OtherDraggable[i].ConnectPoint.length; m++) { //判断其他控件有多少个连接点
							if(OtherDraggable[i].ConnectPoint[m].Mark && ThisActive.ConnectPoint[n].type == OtherDraggable[i].type) {
								for(var v = 0; v < OtherDraggable[i].ConnectPoint[m].SkewAline.length; v++) { //每个连接点都有四条线 循环判断是否达到斜率30°条件

									var OtherDraggablePoint = this.getters['defaultImgOptions/calculateRotate']({
										x: OtherDraggable[i].ConnectPoint[m].x - parseInt(OtherDraggable[i].width / 2),
										y: OtherDraggable[i].ConnectPoint[m].y - parseInt(OtherDraggable[i].height / 2)
									}, OtherDraggable[i].rotateDeg, OtherDraggable[i].width);
									var OtherDraggableConnectPointX = OtherDraggable[i].x + (parseInt((OtherDraggable[i].width / 2) + OtherDraggablePoint.x));
									var OtherDraggableConnectPointY;
									if(OtherDraggable[i].rotateDeg == 0 || OtherDraggable[i].rotateDeg == 90) {
										OtherDraggableConnectPointY = OtherDraggable[i].y + (parseInt((OtherDraggable[i].height / 2) + OtherDraggablePoint.y));
									} else {
										OtherDraggableConnectPointY = OtherDraggable[i].y + (parseInt((OtherDraggable[i].height / 2) - OtherDraggablePoint.y));
									}

									var NewPoint = this.getters['defaultImgOptions/calculateRotate']({
										x: ThisActive.ConnectPoint[n].x - parseInt(ThisActive.width / 2),
										y: ThisActive.ConnectPoint[n].y - parseInt(ThisActive.height / 2)
									}, ThisActive.rotateDeg, ThisActive.width);
									var NewPointX = ThisActive.x + (parseInt((ThisActive.width / 2) + NewPoint.x));
									var NewPointY;
									if(ThisActive.rotateDeg == 0 || ThisActive.rotateDeg == 90) {
										NewPointY = ThisActive.y + (parseInt((ThisActive.height / 2) + NewPoint.y))
									} else {
										NewPointY = ThisActive.y + (parseInt((ThisActive.height / 2) - NewPoint.y))
									}

									if(OtherDraggable[i].ConnectPoint[m].SkewAline[v].name == 'LeftTop') {
										/*
										 * 接入左下方
										 */
										if(NewPointX > OtherDraggableConnectPointX && NewPointY < OtherDraggableConnectPointY) {

											var v_x = Math.round(OtherDraggableConnectPointY * sqrtOpen(3));
											var va = v_x + OtherDraggableConnectPointX; //点v(va,0)

											var x = NewPointX;
											var y = NewPointY;
											var x1 = va;
											var x2 = OtherDraggableConnectPointX;
											var y1 = 0;
											var y2 = OtherDraggableConnectPointY;

											var distance_ab = OtherDraggableConnectPointY - NewPointY;
											var distance_length = distance_ab * 2;

											if(MathFloor((x - x1) / (x2 - x1)) >= MathFloor((y - y1) / (y2 - y1)) - state.SkewAlineAmplitude && MathFloor((x - x1) / (x2 - x1)) <= MathFloor((y - y1) / (y2 - y1)) + state.SkewAlineAmplitude && y2 != 0) {
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark = true;
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].width = distance_length;
											} else if(OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark) {
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark = false;
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].width = 0;
											}
										} else {
											OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark = false;
											OtherDraggable[i].ConnectPoint[m].SkewAline[v].width = 0;
										}
									} else if(OtherDraggable[i].ConnectPoint[m].SkewAline[v].name == 'LeftTop_vm') {
										/*
										 * 接入右上方
										 */

										if(NewPointX < OtherDraggableConnectPointX && NewPointY > OtherDraggableConnectPointY) {

											var v_x = Math.round(OtherDraggableConnectPointY * sqrtOpen(3));
											var va = v_x + OtherDraggableConnectPointX; //点v(va,0)

											var x = NewPointX;
											var y = NewPointY;
											var x1 = va;
											var x2 = OtherDraggableConnectPointX;
											var y1 = 0;
											var y2 = OtherDraggableConnectPointY;

											var distance_ab = OtherDraggableConnectPointY - NewPointY;
											var distance_length = -(distance_ab) * 2;

											if(MathFloor((x - x1) / (x2 - x1)) >= MathFloor((y - y1) / (y2 - y1)) - state.SkewAlineAmplitude && MathFloor((x - x1) / (x2 - x1)) <= MathFloor((y - y1) / (y2 - y1)) + state.SkewAlineAmplitude && y2 != 0) {
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark = true;
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].width = distance_length;
											} else if(OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark) {
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark = false;
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].width = 0;
											}
										} else {
											OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark = false;
											OtherDraggable[i].ConnectPoint[m].SkewAline[v].width = 0;
										}

									} else if(OtherDraggable[i].ConnectPoint[m].SkewAline[v].name == 'LeftBottom') {
										/*
										 * 接入右下方
										 */

										if(NewPointX < OtherDraggableConnectPointX && NewPointY < OtherDraggableConnectPointY) {

											var v_x = Math.round(OtherDraggableConnectPointY * sqrtOpen(3));
											var va = -(v_x - OtherDraggableConnectPointX); //点v(v,0)

											var x = NewPointX;
											var y = NewPointY;
											var x1 = va;
											var x2 = OtherDraggableConnectPointX;
											var y1 = 0;
											var y2 = OtherDraggableConnectPointY;
											//(x1,y1) : (v,0)
											//(x2,y2) : (OtherDraggableConnectPointX,OtherDraggableConnectPointY);
											/*
											 * 直线方程 (x-x1)/(x2-x1)=(y-y1)/(y2-y1)
											 */
											var distance_ab = OtherDraggableConnectPointY - NewPointY;
											var distance_length = distance_ab * 2;

											if(MathFloor((x - x1) / (x2 - x1)) >= MathFloor((y - y1) / (y2 - y1)) - state.SkewAlineAmplitude && MathFloor((x - x1) / (x2 - x1)) <= MathFloor((y - y1) / (y2 - y1)) + state.SkewAlineAmplitude && y2 != 0) {
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark = true;
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].width = distance_length;
											} else if(OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark) {
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark = false;
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].width = 0;
											}
										} else {
											OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark = false;
											OtherDraggable[i].ConnectPoint[m].SkewAline[v].width = 0;
										}

									} else if(OtherDraggable[i].ConnectPoint[m].SkewAline[v].name == 'LeftBottom_vm') {
										/*
										 * 接入左上方
										 */
										if(NewPointX > OtherDraggableConnectPointX && NewPointY > OtherDraggableConnectPointY) {

											var v_x = Math.round(OtherDraggableConnectPointY * sqrtOpen(3));
											var va = -(v_x - OtherDraggableConnectPointX); //点v(v,0)

											var x = NewPointX;
											var y = NewPointY;
											var x1 = va;
											var x2 = OtherDraggableConnectPointX;
											var y1 = 0;
											var y2 = OtherDraggableConnectPointY;
											//(x1,y1) : (v,0)
											//(x2,y2) : (OtherDraggableConnectPointX,OtherDraggableConnectPointY);
											/*
											 * 直线方程 (x-x1)/(x2-x1)=(y-y1)/(y2-y1)
											 */
											var distance_ab = OtherDraggableConnectPointY - NewPointY;
											var distance_length = -(distance_ab) * 2;

											if(MathFloor((x - x1) / (x2 - x1)) >= MathFloor((y - y1) / (y2 - y1)) - state.SkewAlineAmplitude && MathFloor((x - x1) / (x2 - x1)) <= MathFloor((y - y1) / (y2 - y1)) + state.SkewAlineAmplitude && y2 != 0) {
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark = true;
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].width = distance_length;
											} else if(OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark) {
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark = false;
												OtherDraggable[i].ConnectPoint[m].SkewAline[v].width = 0;
											}
										} else {
											OtherDraggable[i].ConnectPoint[m].SkewAline[v].Mark = false;
											OtherDraggable[i].ConnectPoint[m].SkewAline[v].width = 0;
										}
									}

								}
							}
						}
					}
				}

			}
		},

		//zIndex置顶
		zIndexTop(state, index) {
			var max = state.draggable[0].zIndex;

			for(var i = 1; i < state.draggable.length; i++) {
				var cur = state.draggable[i].zIndex;
				cur > max ? max = cur : null
			}

			var ThisActiveArr = state.draggable.filter(item => item.active == true);
			for(var n = 0; n < ThisActiveArr.length; n++) {
				ThisActiveArr[n].zIndex = max + 1;
			}
		},
		//zIndex置底
		zIndexBottom(state, index) {
			var min = state.draggable[0].zIndex;
			var ThisActiveArr = state.draggable.filter(item => item.active == true);
			var OtherDraggable = state.draggable.filter(item => item.active != true);

			for(var i = 1; i < state.draggable.length; i++) {
				var cur = state.draggable[i].zIndex;
				cur < min ? min = cur : null
			}

			if(min == 0) {
				for(var a = 0; a < ThisActiveArr.length; a++) {
					ThisActiveArr[a].zIndex = min;
				}
				for(var a = 0; a < OtherDraggable.length; a++) {
					OtherDraggable[a].zIndex += 1;
				}
			} else {
				for(var n = 0; n < ThisActiveArr.length; n++) {
					ThisActiveArr[n].zIndex = min - 1;
				}
			}

		},
		//zIndex上移一层
		zIndexMoveUp(state, index) {
			var ThisActiveArr = state.draggable.filter(item => item.active == true);
			for(var n = 0; n < ThisActiveArr.length; n++) {
				ThisActiveArr[n].zIndex += 1;
			}
		},
		//zIndex下移一层
		zIndexMoveDown(state, index) {
			var min = state.draggable[0].zIndex;
			var ThisActiveArr = state.draggable.filter(item => item.active == true);
			var OtherDraggable = state.draggable.filter(item => item.active != true);

			for(var i = 1; i < state.draggable.length; i++) {
				var cur = state.draggable[i].zIndex;
				cur < min ? min = cur : null
			}

			if(min == 0) {
				for(var a = 0; a < ThisActiveArr.length; a++) {
					ThisActiveArr[a].zIndex = min;
				}
				for(var a = 0; a < OtherDraggable.length; a++) {
					OtherDraggable[a].zIndex += 1;
				}
			} else {
				for(var n = 0; n < ThisActiveArr.length; n++) {
					ThisActiveArr[n].zIndex -= 1;
				}
			}
		},
		//zIndex修改
		zIndexUpdata(state, zIndex) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			ThisActive.zIndex = parseInt(zIndex);
		},
		//转接头样式修改
		NearAdapterUpdata(state, val) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			if(val == -1) {
				ThisActive.NearEndMark = false;
				ThisActive.NearEndImgUrl = null;
				ThisActive.NearNum = val;
			} else {
				for(var i = 0; i < state.adapter.length; i++) {
					if(state.adapter[i].id == parseInt(val)) {
						ThisActive.NearEndMark = true;
						ThisActive.NearEndImgUrl = state.adapter[i].url;
						ThisActive.NearNum = state.adapter[i].id;
					}
				}
			}
		},
		NearAdapterClear(state, val) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			ThisActive.NearEndMark = false;
			ThisActive.NearEndImgUrl = null;
			ThisActive.NearNum = null;
		},
		FarAdapterUpdata(state, val) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			if(val == -1) {
				ThisActive.FarEndMark = false;
				ThisActive.FarEndImgUrl = null;
				ThisActive.FarNum = val;
			} else {
				for(var i = 0; i < state.adapter.length; i++) {
					if(state.adapter[i].id == parseInt(val)) {
						ThisActive.FarEndMark = true;
						ThisActive.FarEndImgUrl = state.adapter[i].url;
						ThisActive.FarNum = state.adapter[i].id;
					}
				}
			}

		},
		FarAdapterClear(state, val) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			ThisActive.FarEndMark = false;
			ThisActive.FarEndImgUrl = null;
			ThisActive.FarNum = null;
		},
		//自动附着设备斜对齐线
		AutoAttachEquiSkewAlignment(state, index) {
			//开根号
			function sqrtOpen(m) {
				if(1 === m) return 1;
				if(0 === m) return 0;
				if(m < 0) return NaN;
				var s = m / 2;
				var last;
				while(last != s) {
					last = s;
					s = 1 / 2 * (s + m / s)
				}
				return s;
			}

			var ThisActive = state.draggable.filter(item => item.index == index)[0];
			if(ThisActive.rotateDeg != 0) return;
			var OtherDraggable = state.draggable.filter(item => item.index != index && item.ShowActive);
			for(var i = 0; i < OtherDraggable.length; i++) {
				for(var v = 0; v < OtherDraggable[i].SkewAline.length; v++) {
					if(OtherDraggable[i].SkewAline[v].Mark) {
						if(OtherDraggable[i].SkewAline[v].name == 'LeftTop_vm') {
							/*
							 * 左上角去左下方 A
							 */
							if(OtherDraggable[i].x > ThisActive.x && OtherDraggable[i].y < ThisActive.y) {
								var x = Math.round(OtherDraggable[i].x / sqrtOpen(3));
								var ab = x;
								var bc = 2 * x;
								var bd = ab + OtherDraggable[i].y; // b点(0,bd); (x1,y1)
								var de = Math.round(bd * sqrtOpen(3)); // e点(de,0); (x2,y2)

								var distance_ab = ThisActive.y - OtherDraggable[i].y;
								var distance_ac = OtherDraggable[i].x - ThisActive.x;
								var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
								var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));
								/*
								 * 斜率公式  k = (y2 - y1) / (x2 - x1)
								 */
								/*
								 * 直线方程 (x-x1)/(x2-x1)=(y-y1)/(y2-y1)
								 */
								//var OtherDraggableSlope = ( 0 - bd) / ( de - 0);//OtherDraggable[i]斜率
								//var ThisActiveSlope = ThisActive.height / ThisActive.width;//ThisActive斜率
								/*
								 * 判断ThisActive的(x,y)是否在该直线方程上
								 */
								if(Math.floor(ThisActive.x / de * 100) / 100 >= (Math.floor((ThisActive.y - bd) / (-bd) * 100) / 100) - state.SkewAlineAmplitude && Math.floor(ThisActive.x / de * 100) / 100 <= (Math.floor((ThisActive.y - bd) / (-bd) * 100) / 100) + state.SkewAlineAmplitude && bd != 0) {
									//ThisActive.x = parseInt((ThisActive.y - bd) / (-bd) * de);
									var NewThisActivey = parseInt((ThisActive.x / de * (-bd)) + bd);
									var delY = NewThisActivey - ThisActive.y
									ThisActive.y += delY;
									ThisActive.centerPointY += delY;
								}

							}
						} else if(OtherDraggable[i].SkewAline[v].name == 'LeftTop') {
							/*
							 * 左上角去右上方 A
							 */
							if(ThisActive.x > OtherDraggable[i].x && ThisActive.y < OtherDraggable[i].y) {
								var x = Math.round(OtherDraggable[i].x / sqrtOpen(3));
								var ab = x;
								var bd = ab + OtherDraggable[i].y; // b点(0,bd); (x1,y1)
								var de = Math.round(bd * sqrtOpen(3)); // e点(de,0); (x2,y2)

								var distance_ab = ThisActive.y - OtherDraggable[i].y;
								var distance_ac = OtherDraggable[i].x - ThisActive.x;
								var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
								var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));
								if(Math.floor(ThisActive.x / de * 100) / 100 >= (Math.floor((ThisActive.y - bd) / (-bd) * 100) / 100) - state.SkewAlineAmplitude && Math.floor(ThisActive.x / de * 100) / 100 <= (Math.floor((ThisActive.y - bd) / (-bd) * 100) / 100) + state.SkewAlineAmplitude && bd != 0) {
									//ThisActive.x = parseInt((ThisActive.y - bd) / (-bd) * de);
									var NewThisActivey = parseInt((ThisActive.x / de * (-bd)) + bd);
									var delY = NewThisActivey - ThisActive.y
									ThisActive.y += delY;
									ThisActive.centerPointY += delY;
								}
							}
						} else if(OtherDraggable[i].SkewAline[v].name == 'RightBottom') {
							/*
							 * 右下角去左下方 D
							 */
							if(OtherDraggable[i].y + OtherDraggable[i].height < ThisActive.y + ThisActive.height && OtherDraggable[i].x + OtherDraggable[i].width > ThisActive.x + ThisActive.width) {
								var x = Math.round((OtherDraggable[i].x + OtherDraggable[i].width) / sqrtOpen(3));
								var ab = x;
								var bd = ab + OtherDraggable[i].height + OtherDraggable[i].y; // b点(0,bd); (x1,y1)
								var de = Math.round(bd * sqrtOpen(3)); // e点(de,0); (x2,y2)

								var distance_ab = (ThisActive.y + ThisActive.height) - (OtherDraggable[i].y + OtherDraggable[i].height);
								var distance_ac = (OtherDraggable[i].x + OtherDraggable[i].width) - (ThisActive.x + ThisActive.width);
								var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
								var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));

								if(Math.floor(((ThisActive.x + ThisActive.width) - 0) / (de - 0) * 100) / 100 >= (Math.floor((ThisActive.y + ThisActive.height - bd) / (0 - bd) * 100) / 100) - state.SkewAlineAmplitude && Math.floor(((ThisActive.x + ThisActive.width) - 0) / (de - 0) * 100) / 100 <= (Math.floor((ThisActive.y + ThisActive.height - bd) / (0 - bd) * 100) / 100) + state.SkewAlineAmplitude && bd != 0) {
									//ThisActive.x = parseInt(((ThisActive.y + ThisActive.height - bd) / (-bd) * de) - ThisActive.width);
									var NewThisActivey = parseInt((((ThisActive.x + ThisActive.width) / de * (-bd)) + bd) - ThisActive.height)
									var delY = NewThisActivey - ThisActive.y
									ThisActive.y += delY;
									ThisActive.centerPointY += delY;
								}
							}
						} else if(OtherDraggable[i].SkewAline[v].name == 'RightBottom_vm') {
							/*
							 * 右上角去右上方 D
							 */
							if(ThisActive.x > OtherDraggable[i].x + OtherDraggable[i].width && OtherDraggable[i].y + OtherDraggable[i].height > ThisActive.y + ThisActive.height) {
								var x = Math.round((OtherDraggable[i].x + OtherDraggable[i].width) / sqrtOpen(3));
								var ab = x;
								var bd = ab + OtherDraggable[i].height + OtherDraggable[i].y; // b点(0,bd); (x1,y1)
								var de = Math.round(bd * sqrtOpen(3)); // e点(de,0); (x2,y2)

								var distance_ab = (ThisActive.y + ThisActive.height) - (OtherDraggable[i].y + OtherDraggable[i].height);
								var distance_ac = (OtherDraggable[i].x + OtherDraggable[i].width) - (ThisActive.x + ThisActive.width);
								var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
								var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));

								if(Math.floor(((ThisActive.x + ThisActive.width) - 0) / (de - 0) * 100) / 100 >= (Math.floor((ThisActive.y + ThisActive.height - bd) / (0 - bd) * 100) / 100) - state.SkewAlineAmplitude && Math.floor(((ThisActive.x + ThisActive.width) - 0) / (de - 0) * 100) / 100 <= (Math.floor((ThisActive.y + ThisActive.height - bd) / (0 - bd) * 100) / 100) + state.SkewAlineAmplitude && bd != 0) {
									//ThisActive.x = parseInt(((ThisActive.y + ThisActive.height - bd) / (-bd) * de) - ThisActive.width);
									var NewThisActivey = parseInt((((ThisActive.x + ThisActive.width) / de * (-bd)) + bd) - ThisActive.height);
									var delY = NewThisActivey - ThisActive.y
									ThisActive.y += delY;
									ThisActive.centerPointY += delY;
								}
							}
						} else if(OtherDraggable[i].SkewAline[v].name == 'RightTop') {
							/*
							 * 右上角去右下方 C
							 */
							if(ThisActive.y > OtherDraggable[i].y && ThisActive.x + ThisActive.width > OtherDraggable[i].x + OtherDraggable[i].width) {
								var x = OtherDraggable[i].y;
								var ef = Math.round(x * sqrtOpen(3));
								var ePoint = -(ef - (OtherDraggable[i].x + OtherDraggable[i].width))
								// e点(ePoint,0); (x1,y1)
								// c点(OtherDraggable[i].x+OtherDraggable[i].width, OtherDraggable[i].y); (x2,y2)

								var distance_ab = ThisActive.y - OtherDraggable[i].y;
								var distance_ac = (ThisActive.x + ThisActive.width) - (OtherDraggable[i].x + OtherDraggable[i].width);
								var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
								var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));

								var vm_x = ThisActive.x + ThisActive.width;
								var vm_x1 = ePoint;
								var vm_x2 = OtherDraggable[i].x + OtherDraggable[i].width;
								var vm_y = ThisActive.y;
								var vm_y1 = 0;
								var vm_y2 = OtherDraggable[i].y;
								if(Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 >= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) - state.SkewAlineAmplitude && Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 <= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) + state.SkewAlineAmplitude && vm_y2 != 0) {
									//ThisActive.x = parseInt((((ThisActive.y-0)*(OtherDraggable[i].x+OtherDraggable[i].width-ePoint))/(OtherDraggable[i].y-0))+ePoint) - ThisActive.width
									var NewThisActivey = parseInt(((vm_x - vm_x1) * (vm_y2 - vm_y1)) / (vm_x2 - vm_x1))
									var delY = NewThisActivey - ThisActive.y
									ThisActive.y += delY;
									ThisActive.centerPointY += delY;
								}
							}
						} else if(OtherDraggable[i].SkewAline[v].name == 'RightTop_vm') {
							/*
							 * 右上角去左上方 C
							 */
							if(ThisActive.y < OtherDraggable[i].y && ThisActive.x + ThisActive.width < OtherDraggable[i].x + OtherDraggable[i].width) {
								var x = OtherDraggable[i].y;
								var ef = Math.round(x * sqrtOpen(3));
								var ePoint = -(ef - (OtherDraggable[i].x + OtherDraggable[i].width))
								// e点(ePoint,0); (x1,y1)
								// c点(OtherDraggable[i].x+OtherDraggable[i].width, OtherDraggable[i].y); (x2,y2)

								var distance_ab = ThisActive.y - OtherDraggable[i].y;
								var distance_ac = (ThisActive.x + ThisActive.width) - (OtherDraggable[i].x + OtherDraggable[i].width);
								var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
								var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));

								var vm_x = ThisActive.x + ThisActive.width;
								var vm_x1 = ePoint;
								var vm_x2 = OtherDraggable[i].x + OtherDraggable[i].width;
								var vm_y = ThisActive.y;
								var vm_y1 = 0;
								var vm_y2 = OtherDraggable[i].y;
								if(Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 >= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) - state.SkewAlineAmplitude && Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 <= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) + state.SkewAlineAmplitude && vm_y2 != 0) {
									//ThisActive.x = parseInt((((ThisActive.y-0)*(OtherDraggable[i].x+OtherDraggable[i].width-ePoint))/(OtherDraggable[i].y-0))+ePoint ) - ThisActive.width
									var NewThisActivey = parseInt(((vm_x - vm_x1) * (vm_y2 - vm_y1)) / (vm_x2 - vm_x1))
									var delY = NewThisActivey - ThisActive.y
									ThisActive.y += delY;
									ThisActive.centerPointY += delY;
								}
							}
						} else if(OtherDraggable[i].SkewAline[v].name == 'LeftBottom') {
							/*
							 * 左下角去左上方 B
							 */
							if(ThisActive.y < OtherDraggable[i].y && ThisActive.x < OtherDraggable[i].x) {
								var x = OtherDraggable[i].y + OtherDraggable[i].height;
								var ef = Math.round(x * sqrtOpen(3));
								var ePoint = -(ef - OtherDraggable[i].x)
								// e点(ePoint,0); (x1,y1)
								// c点(OtherDraggable[i].x, OtherDraggable[i].y+OtherDraggable[i].height); (x2,y2)

								var distance_ab = (ThisActive.y + ThisActive.height) - (OtherDraggable[i].y + OtherDraggable[i].height);
								var distance_ac = ThisActive.x - OtherDraggable[i].x;
								var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
								var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));

								var vm_x = ThisActive.x;
								var vm_x1 = ePoint;
								var vm_x2 = OtherDraggable[i].x;
								var vm_y = ThisActive.y + ThisActive.height;
								var vm_y1 = 0;
								var vm_y2 = OtherDraggable[i].y + OtherDraggable[i].height;
								if(Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 >= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) - state.SkewAlineAmplitude && Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 <= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) + state.SkewAlineAmplitude && vm_y2 != 0) {
									//ThisActive.x = parseInt((((vm_y-vm_y1)*(vm_x2-vm_x1))/(vm_y2-vm_y1))+vm_x1 )
									var NewThisActivey = parseInt(((vm_x - vm_x1) * (vm_y2 - vm_y1)) / (vm_x2 - vm_x1)) - ThisActive.height
									var delY = NewThisActivey - ThisActive.y
									ThisActive.y += delY;
									ThisActive.centerPointY += delY;
								}
							}
						} else if(OtherDraggable[i].SkewAline[v].name == 'LeftBottom_vm') {
							/*
							 * 左下角去右下方 B
							 */
							if(ThisActive.y > OtherDraggable[i].y && ThisActive.x > OtherDraggable[i].x) {
								var x = OtherDraggable[i].y + OtherDraggable[i].height;
								var ef = Math.round(x * sqrtOpen(3));
								var ePoint = -(ef - OtherDraggable[i].x)
								// e点(ePoint,0); (x1,y1)
								// c点(OtherDraggable[i].x, OtherDraggable[i].y+OtherDraggable[i].height); (x2,y2)

								var distance_ab = (ThisActive.y + ThisActive.height) - (OtherDraggable[i].y + OtherDraggable[i].height);
								var distance_ac = ThisActive.x - OtherDraggable[i].x;
								var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
								var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));

								var vm_x = ThisActive.x;
								var vm_x1 = ePoint;
								var vm_x2 = OtherDraggable[i].x;
								var vm_y = ThisActive.y + ThisActive.height;
								var vm_y1 = 0;
								var vm_y2 = OtherDraggable[i].y + OtherDraggable[i].height;
								if(Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 >= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) - state.SkewAlineAmplitude && Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 <= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) + state.SkewAlineAmplitude && vm_y2 != 0) {
									//ThisActive.x = parseInt((((vm_y-vm_y1)*(vm_x2-vm_x1))/(vm_y2-vm_y1))+vm_x1 )
									var NewThisActivey = parseInt(((vm_x - vm_x1) * (vm_y2 - vm_y1)) / (vm_x2 - vm_x1)) - ThisActive.height
									var delY = NewThisActivey - ThisActive.y
									ThisActive.y += delY;
									ThisActive.centerPointY += delY;
								}
							}
						}
					}
				}
			}
		},
		//自动附着斜对齐线
		AutoAttachSkewAlignment(state, id) {
			//开根号
			function sqrtOpen(m) {
				if(1 === m) return 1;
				if(0 === m) return 0;
				if(m < 0) return NaN;
				var s = m / 2;
				var last;
				while(last != s) {
					last = s;
					s = 1 / 2 * (s + m / s)
				}
				return s;
			}

			function MathFloor(num) {
				return Math.floor(num * 100) / 100;
			}
			var ThisActive = state.draggable.filter(item => item.index == id)[0];
			var OtherDraggable = state.draggable.filter(item => item.index != id && item.ShowActive);
			for(var i = 0; i < OtherDraggable.length; i++) {
				for(var n = 0; n < ThisActive.ConnectPoint.length; n++) { //判断选中的有多少个连接点
					if(ThisActive.ConnectPoint[n].Mark) {
						for(var m = 0; m < OtherDraggable[i].ConnectPoint.length; m++) { //判断其他控件有多少个连接点
							if(OtherDraggable[i].ConnectPoint[m].Mark && ThisActive.ConnectPoint[n].type == OtherDraggable[i].type) {
								for(var v = 0; v < OtherDraggable[i].ConnectPoint[m].SkewAline.length; v++) { //每个连接点都有四条线 循环判断是否达到斜率30°条件

									var OtherDraggablePoint = this.getters['defaultImgOptions/calculateRotate']({
										x: OtherDraggable[i].ConnectPoint[m].x - parseInt(OtherDraggable[i].width / 2),
										y: OtherDraggable[i].ConnectPoint[m].y - parseInt(OtherDraggable[i].height / 2)
									}, OtherDraggable[i].rotateDeg, OtherDraggable[i].width);
									var OtherDraggableConnectPointX = OtherDraggable[i].x + (parseInt((OtherDraggable[i].width / 2) + OtherDraggablePoint.x));
									var OtherDraggableConnectPointY;
									if(OtherDraggable[i].rotateDeg == 0 || OtherDraggable[i].rotateDeg == 90) {
										OtherDraggableConnectPointY = OtherDraggable[i].y + (parseInt((OtherDraggable[i].height / 2) + OtherDraggablePoint.y));
									} else {
										OtherDraggableConnectPointY = OtherDraggable[i].y + (parseInt((OtherDraggable[i].height / 2) - OtherDraggablePoint.y));
									}

									var NewPoint = this.getters['defaultImgOptions/calculateRotate']({
										x: ThisActive.ConnectPoint[n].x - parseInt(ThisActive.width / 2),
										y: ThisActive.ConnectPoint[n].y - parseInt(ThisActive.height / 2)
									}, ThisActive.rotateDeg, ThisActive.width);
									var NewPointX = ThisActive.x + (parseInt((ThisActive.width / 2) + NewPoint.x));
									var NewPointY;
									if(ThisActive.rotateDeg == 0 || ThisActive.rotateDeg == 90) {
										NewPointY = ThisActive.y + (parseInt((ThisActive.height / 2) + NewPoint.y))
									} else {
										NewPointY = ThisActive.y + (parseInt((ThisActive.height / 2) - NewPoint.y))
									}

									if(OtherDraggable[i].ConnectPoint[m].SkewAline[v].name == 'LeftTop') {
										/*
										 * 接入左下方
										 */
										if(NewPointX > OtherDraggableConnectPointX && NewPointY < OtherDraggableConnectPointY) {

											var v_x = Math.round(OtherDraggableConnectPointY * sqrtOpen(3));
											var va = v_x + OtherDraggableConnectPointX; //点v(va,0)

											var x = NewPointX;
											var y = NewPointY;
											var x1 = va;
											var x2 = OtherDraggableConnectPointX;
											var y1 = 0;
											var y2 = OtherDraggableConnectPointY;

											var distance_ab = OtherDraggableConnectPointY - NewPointY;
											var distance_length = distance_ab * 2;

											if(MathFloor((x - x1) / (x2 - x1)) >= MathFloor((y - y1) / (y2 - y1)) - state.SkewAlineAmplitude && MathFloor((x - x1) / (x2 - x1)) <= MathFloor((y - y1) / (y2 - y1)) + state.SkewAlineAmplitude && y2 != 0) {
												var NewPointY_auto = parseInt((((x - x1) * (y2 - y1)) / (x2 - x1)) + y1);
												var auto_Difference = NewPointY_auto - NewPointY;
												ThisActive.centerPointY += auto_Difference;
												ThisActive.y += auto_Difference;
											}
										}
									} else if(OtherDraggable[i].ConnectPoint[m].SkewAline[v].name == 'LeftTop_vm') {
										/*
										 * 接入右上方
										 */

										if(NewPointX < OtherDraggableConnectPointX && NewPointY > OtherDraggableConnectPointY) {

											var v_x = Math.round(OtherDraggableConnectPointY * sqrtOpen(3));
											var va = v_x + OtherDraggableConnectPointX; //点v(va,0)

											var x = NewPointX;
											var y = NewPointY;
											var x1 = va;
											var x2 = OtherDraggableConnectPointX;
											var y1 = 0;
											var y2 = OtherDraggableConnectPointY;

											var distance_ab = OtherDraggableConnectPointY - NewPointY;
											var distance_length = -(distance_ab) * 2;

											if(MathFloor((x - x1) / (x2 - x1)) >= MathFloor((y - y1) / (y2 - y1)) - state.SkewAlineAmplitude && MathFloor((x - x1) / (x2 - x1)) <= MathFloor((y - y1) / (y2 - y1)) + state.SkewAlineAmplitude && y2 != 0) {
												var NewPointY_auto = parseInt((((x - x1) * (y2 - y1)) / (x2 - x1)) + y1);
												var auto_Difference = NewPointY_auto - NewPointY;
												ThisActive.centerPointY += auto_Difference;
												ThisActive.y += auto_Difference;
											}
										}

									} else if(OtherDraggable[i].ConnectPoint[m].SkewAline[v].name == 'LeftBottom') {
										/*
										 * 接入右下方
										 */

										if(NewPointX < OtherDraggableConnectPointX && NewPointY < OtherDraggableConnectPointY) {

											var v_x = Math.round(OtherDraggableConnectPointY * sqrtOpen(3));
											var va = -(v_x - OtherDraggableConnectPointX); //点v(v,0)

											var x = NewPointX;
											var y = NewPointY;
											var x1 = va;
											var x2 = OtherDraggableConnectPointX;
											var y1 = 0;
											var y2 = OtherDraggableConnectPointY;
											//(x1,y1) : (v,0)
											//(x2,y2) : (OtherDraggableConnectPointX,OtherDraggableConnectPointY);
											/*
											 * 直线方程 (x-x1)/(x2-x1)=(y-y1)/(y2-y1)
											 */
											var distance_ab = OtherDraggableConnectPointY - NewPointY;
											var distance_length = distance_ab * 2;

											if(MathFloor((x - x1) / (x2 - x1)) >= MathFloor((y - y1) / (y2 - y1)) - state.SkewAlineAmplitude && MathFloor((x - x1) / (x2 - x1)) <= MathFloor((y - y1) / (y2 - y1)) + state.SkewAlineAmplitude && y2 != 0) {
												var NewPointY_auto = parseInt((((x - x1) * (y2 - y1)) / (x2 - x1)) + y1);
												var auto_Difference = NewPointY_auto - NewPointY;
												ThisActive.centerPointY += auto_Difference;
												ThisActive.y += auto_Difference;
											}
										}

									} else if(OtherDraggable[i].ConnectPoint[m].SkewAline[v].name == 'LeftBottom_vm') {
										/*
										 * 接入左上方
										 */
										if(NewPointX > OtherDraggableConnectPointX && NewPointY > OtherDraggableConnectPointY) {

											var v_x = Math.round(OtherDraggableConnectPointY * sqrtOpen(3));
											var va = -(v_x - OtherDraggableConnectPointX); //点v(v,0)

											var x = NewPointX;
											var y = NewPointY;
											var x1 = va;
											var x2 = OtherDraggableConnectPointX;
											var y1 = 0;
											var y2 = OtherDraggableConnectPointY;
											//(x1,y1) : (v,0)
											//(x2,y2) : (OtherDraggableConnectPointX,OtherDraggableConnectPointY);
											/*
											 * 直线方程 (x-x1)/(x2-x1)=(y-y1)/(y2-y1)
											 */
											var distance_ab = OtherDraggableConnectPointY - NewPointY;
											var distance_length = -(distance_ab) * 2;

											if(MathFloor((x - x1) / (x2 - x1)) >= MathFloor((y - y1) / (y2 - y1)) - state.SkewAlineAmplitude && MathFloor((x - x1) / (x2 - x1)) <= MathFloor((y - y1) / (y2 - y1)) + state.SkewAlineAmplitude && y2 != 0) {
												var NewPointY_auto = parseInt((((x - x1) * (y2 - y1)) / (x2 - x1)) + y1);
												var auto_Difference = NewPointY_auto - NewPointY;
												ThisActive.centerPointY += auto_Difference;
												ThisActive.y += auto_Difference;
											}
										}
									}

								}
							}
						}
					}
				}

			}
		},

		//自动附着连接点
		AutoAttachConnectPoint(state, ObjectData) {
			var ThisActive = state.draggable.filter(item => item.index == ObjectData)[0];
			var OtherDraggable = state.draggable.filter(item => item.index != ThisActive.index && item.ShowActive);
			for(var i = 0; i < ThisActive.ConnectPoint.length; i++) {
				if(ThisActive.ConnectPoint[i].Mark) {
					for(var a = 0; a < OtherDraggable.length; a++) {
						if(OtherDraggable[a].ConnectMark && ThisActive.ConnectPoint[i].type == OtherDraggable[a].type) {
							for(var n = 0; n < OtherDraggable[a].ConnectPoint.length; n++) {
								if(OtherDraggable[a].ConnectPoint[n].Mark) {

									var OtherDraggableConnectPoint = this.getters['defaultImgOptions/calculateRotate']({
										x: OtherDraggable[a].ConnectPoint[n].x - parseInt(OtherDraggable[a].width / 2),
										y: OtherDraggable[a].ConnectPoint[n].y - parseInt(OtherDraggable[a].height / 2)
									}, OtherDraggable[a].rotateDeg, OtherDraggable[a].width);
									var OtherDraggableConnectPointX = parseInt((OtherDraggable[a].width / 2) + OtherDraggableConnectPoint.x);
									var OtherDraggableConnectPointY;
									if(OtherDraggable[a].rotateDeg == 0 || OtherDraggable[a].rotateDeg == 90) {
										OtherDraggableConnectPointY = parseInt((OtherDraggable[a].height / 2) + OtherDraggableConnectPoint.y);
									} else {
										OtherDraggableConnectPointY = parseInt((OtherDraggable[a].height / 2) - OtherDraggableConnectPoint.y);
									}

									var ObjectDataConnectPoint = this.getters['defaultImgOptions/calculateRotate']({
										x: ThisActive.ConnectPoint[i].x - parseInt(ThisActive.width / 2),
										y: ThisActive.ConnectPoint[i].y - parseInt(ThisActive.height / 2)
									}, ThisActive.rotateDeg, ThisActive.width);
									var ObjectDataConnectPointX = parseInt((ThisActive.width / 2) + ObjectDataConnectPoint.x);
									var ObjectDataConnectPointY;
									if(ThisActive.rotateDeg == 0 || ThisActive.rotateDeg == 90) {
										ObjectDataConnectPointY = parseInt((ThisActive.height / 2) + ObjectDataConnectPoint.y)
									} else {
										ObjectDataConnectPointY = parseInt((ThisActive.height / 2) - ObjectDataConnectPoint.y)
									}

									//									console.log(ThisActive.x+ObjectDataConnectPointX,ThisActive.y+ObjectDataConnectPointY)
									if(((OtherDraggable[a].x + OtherDraggableConnectPointX) - (ThisActive.x + ObjectDataConnectPointX)) < state.ConnectPointAttachMargin && ((OtherDraggable[a].y + OtherDraggableConnectPointY) - (ThisActive.y + ObjectDataConnectPointY)) < state.ConnectPointAttachMargin && ((ThisActive.y + ObjectDataConnectPointY) - (OtherDraggable[a].y + OtherDraggableConnectPointY)) < state.ConnectPointAttachMargin && ((ThisActive.x + ObjectDataConnectPointX) - (OtherDraggable[a].x + OtherDraggableConnectPointX)) < state.ConnectPointAttachMargin) {

										var GoMark = false;
										if(ThisActive.rotateDeg == -30 && OtherDraggable[a].rotateDeg == 30) {
											/* ThisActive：-30, OtherDraggable：30 开始 */
											if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
												if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
													if(ThisActive.NearNum == 6 || ThisActive.NearNum == 7 || ThisActive.NearNum == 18) {
														GoMark = true;
													}
													if(OtherDraggable[a].FarNum == 6 || OtherDraggable[a].FarNum == 7 || OtherDraggable[a].FarNum == 18) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
												if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
													if(ThisActive.FarNum == 1 || ThisActive.FarNum == 4 || ThisActive.FarNum == 18) {
														GoMark = true;
													}
													if(OtherDraggable[a].FarNum == 1 || OtherDraggable[a].FarNum == 4 || OtherDraggable[a].FarNum == 18) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
												if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
													if(ThisActive.NearNum == 0 || ThisActive.NearNum == 7 || ThisActive.NearNum == 9) {
														GoMark = true;
													}
													if(OtherDraggable[a].NearNum == 0 || OtherDraggable[a].NearNum == 7 || OtherDraggable[a].NearNum == 9) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
												if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
													if(ThisActive.FarNum == 1 || ThisActive.FarNum == 8 || ThisActive.FarNum == 9) {
														GoMark = true;
													}
													if(OtherDraggable[a].NearNum == 1 || OtherDraggable[a].NearNum == 8 || OtherDraggable[a].NearNum == 9) {
														GoMark = true;
													}
												}
											}
											/* ThisActive：-30, OtherDraggable：30 结束 */

										} else if(ThisActive.rotateDeg == 30 && OtherDraggable[a].rotateDeg == -30) {
											/* ThisActive：30, OtherDraggable：-30 开始 */
											if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
												if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
													if(ThisActive.FarNum == 6 || ThisActive.FarNum == 7 || ThisActive.FarNum == 18) {
														GoMark = true;
													}
													if(OtherDraggable[a].NearNum == 6 || OtherDraggable[a].NearNum == 7 || OtherDraggable[a].NearNum == 18) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
												if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
													if(ThisActive.NearNum == 0 || ThisActive.NearNum == 7 || ThisActive.NearNum == 9) {
														GoMark = true;
													}
													if(OtherDraggable[a].NearNum == 0 || OtherDraggable[a].NearNum == 7 || OtherDraggable[a].NearNum == 9) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
												if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
													if(ThisActive.FarNum == 1 || ThisActive.FarNum == 4 || ThisActive.FarNum == 18) {
														GoMark = true;
													}
													if(OtherDraggable[a].FarNum == 1 || OtherDraggable[a].FarNum == 4 || OtherDraggable[a].FarNum == 18) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
												if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
													if(ThisActive.NearNum == 1 || ThisActive.NearNum == 8 || ThisActive.NearNum == 9) {
														GoMark = true;
													}
													if(OtherDraggable[a].FarNum == 1 || OtherDraggable[a].FarNum == 8 || OtherDraggable[a].FarNum == 9) {
														GoMark = true;
													}
												}
											}
											/* ThisActive：30, OtherDraggable：-30 结束 */

										} else if(ThisActive.rotateDeg == 30 && OtherDraggable[a].rotateDeg == 90) {
											/* ThisActive：30, OtherDraggable：90 开始 */
											if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
												if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
													if(ThisActive.NearNum == 14 || ThisActive.NearNum == 21 || ThisActive.NearNum == 22) {
														GoMark = true;
													}
													if(OtherDraggable[a].FarNum == 14 || OtherDraggable[a].FarNum == 21 || OtherDraggable[a].FarNum == 22) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
												if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
													if(ThisActive.FarNum == 12 || ThisActive.FarNum == 21 || ThisActive.FarNum == 19) {
														GoMark = true;
													}
													if(OtherDraggable[a].FarNum == 12 || OtherDraggable[a].FarNum == 21 || OtherDraggable[a].FarNum == 19) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
												if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
													if(ThisActive.FarNum == 10 || ThisActive.FarNum == 12 || ThisActive.FarNum == 20) {
														GoMark = true;
													}
													if(OtherDraggable[a].NearNum == 10 || OtherDraggable[a].NearNum == 12 || OtherDraggable[a].NearNum == 20) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
												if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
													if(ThisActive.NearNum == 14 || ThisActive.NearNum == 23 || ThisActive.NearNum == 20) {
														GoMark = true;
													}
													if(OtherDraggable[a].NearNum == 14 || OtherDraggable[a].NearNum == 23 || OtherDraggable[a].NearNum == 20) {
														GoMark = true;
													}
												}
											}
											/* ThisActive：30, OtherDraggable：90 结束 */

										} else if(ThisActive.rotateDeg == 90 && OtherDraggable[a].rotateDeg == 30) {
											/* ThisActive：90, OtherDraggable：30 开始 */
											if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
												if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
													if(ThisActive.NearNum == 10 || ThisActive.NearNum == 12 || ThisActive.NearNum == 20) {
														GoMark = true;
													}
													if(OtherDraggable[a].FarNum == 10 || OtherDraggable[a].FarNum == 12 || OtherDraggable[a].FarNum == 20) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
												if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
													if(ThisActive.FarNum == 12 || ThisActive.FarNum == 21 || ThisActive.FarNum == 19) {
														GoMark = true;
													}
													if(OtherDraggable[a].FarNum == 12 || OtherDraggable[a].FarNum == 21 || OtherDraggable[a].FarNum == 19) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
												if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
													if(ThisActive.FarNum == 14 || ThisActive.FarNum == 21 || ThisActive.FarNum == 22) {
														GoMark = true;
													}
													if(OtherDraggable[a].NearNum == 14 || OtherDraggable[a].NearNum == 21 || OtherDraggable[a].NearNum == 22) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
												if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
													if(ThisActive.NearNum == 14 || ThisActive.NearNum == 23 || ThisActive.NearNum == 20) {
														GoMark = true;
													}
													if(OtherDraggable[a].NearNum == 14 || OtherDraggable[a].NearNum == 23 || OtherDraggable[a].NearNum == 20) {
														GoMark = true;
													}
												}
											}
											/* ThisActive：90, OtherDraggable：30 结束 */

										} else if(ThisActive.rotateDeg == -30 && OtherDraggable[a].rotateDeg == 90) {
											/* ThisActive：-30, OtherDraggable：90 开始 */
											if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
												if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
													if(ThisActive.FarNum == 2 || ThisActive.FarNum == 5 || ThisActive.FarNum == 13) {
														GoMark = true;
													}
													if(OtherDraggable[a].FarNum == 2 || OtherDraggable[a].FarNum == 5 || OtherDraggable[a].FarNum == 13) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
												if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
													if(ThisActive.NearNum == 3 || ThisActive.NearNum == 5 || ThisActive.NearNum == 11) {
														GoMark = true;
													}
													if(OtherDraggable[a].FarNum == 3 || OtherDraggable[a].FarNum == 5 || OtherDraggable[a].FarNum == 11) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
												if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
													if(ThisActive.NearNum == 16 || ThisActive.NearNum == 17 || ThisActive.NearNum == 11) {
														GoMark = true;
													}
													if(OtherDraggable[a].NearNum == 16 || OtherDraggable[a].NearNum == 17 || OtherDraggable[a].NearNum == 11) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
												if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
													if(ThisActive.FarNum == 15 || ThisActive.FarNum == 17 || ThisActive.FarNum == 13) {
														GoMark = true;
													}
													if(OtherDraggable[a].NearNum == 15 || OtherDraggable[a].NearNum == 17 || OtherDraggable[a].NearNum == 13) {
														GoMark = true;
													}
												}
											}
											/* ThisActive：-30, OtherDraggable：90 结束 */

										} else if(ThisActive.rotateDeg == 90 && OtherDraggable[a].rotateDeg == -30) {
											/* ThisActive：90, OtherDraggable：-30 开始 */
											if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
												if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
													if(ThisActive.NearNum == 16 || ThisActive.NearNum == 17 || ThisActive.NearNum == 11) {
														GoMark = true;
													}
													if(OtherDraggable[a].NearNum == 16 || OtherDraggable[a].NearNum == 17 || OtherDraggable[a].NearNum == 11) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
												if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
													if(ThisActive.FarNum == 3 || ThisActive.FarNum == 5 || ThisActive.FarNum == 11) {
														GoMark = true;
													}
													if(OtherDraggable[a].NearNum == 3 || OtherDraggable[a].NearNum == 5 || OtherDraggable[a].NearNum == 11) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
												if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
													if(ThisActive.FarNum == 2 || ThisActive.FarNum == 5 || ThisActive.FarNum == 13) {
														GoMark = true;
													}
													if(OtherDraggable[a].FarNum == 2 || OtherDraggable[a].FarNum == 5 || OtherDraggable[a].FarNum == 13) {
														GoMark = true;
													}
												}
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
												if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
													if(ThisActive.NearNum == 15 || ThisActive.NearNum == 17 || ThisActive.NearNum == 13) {
														GoMark = true;
													}
													if(OtherDraggable[a].FarNum == 15 || OtherDraggable[a].FarNum == 17 || OtherDraggable[a].FarNum == 13) {
														GoMark = true;
													}
												}
											}
											/* ThisActive：90, OtherDraggable：-30 结束 */

										} else if(ThisActive.rotateDeg == 0 && OtherDraggable[a].rotateDeg == 30) {
											if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && !OtherDraggable[a].FarEndMark) {
												GoMark = true;
											}
										} else if(ThisActive.rotateDeg == 30 && OtherDraggable[a].rotateDeg == 0) {
											if(ThisActive.ConnectPoint[i].typeObj == 'left' && !ThisActive.FarEndMark) {
												GoMark = true;
											}
										} else if(ThisActive.rotateDeg == 0 && OtherDraggable[a].rotateDeg == -30) {
											if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && !OtherDraggable[a].NearEndMark) {
												GoMark = true;
											} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && !OtherDraggable[a].FarEndMark) {
												GoMark = true;
											}
										} else if(ThisActive.rotateDeg == -30 && OtherDraggable[a].rotateDeg == 0) {
											if(ThisActive.ConnectPoint[i].typeObj == 'left' && !ThisActive.NearEndMark) {
												GoMark = true;
											} else if(ThisActive.ConnectPoint[i].typeObj == 'right' && !ThisActive.FarEndMark) {
												GoMark = true;
											}
										} else if(ThisActive.rotateDeg == 0 && OtherDraggable[a].rotateDeg == 90) {
											if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && !OtherDraggable[a].NearEndMark) {
												GoMark = true;
											}
										} else if(ThisActive.rotateDeg == 90 && OtherDraggable[a].rotateDeg == 0) {
											if(ThisActive.ConnectPoint[i].typeObj == 'right' && !ThisActive.NearEndMark) {
												GoMark = true;
											}
										}

										if(GoMark) {
											//
											var NewThisActivex = parseInt(OtherDraggable[a].x + OtherDraggableConnectPointX - ObjectDataConnectPointX);
											var NewThisActivey = parseInt(OtherDraggable[a].y + OtherDraggableConnectPointY - ObjectDataConnectPointY);
											var delX = NewThisActivex - ThisActive.x;
											var delY = NewThisActivey - ThisActive.y;
											ThisActive.centerPointX += delX;
											ThisActive.centerPointY += delY;
											ThisActive.x += delX;
											ThisActive.y += delY;
										}
									}
								}

							}
						}

					}
				}
			}
		},

		//连接点更新 差距计算
		ConnectionPointUpdata(state, ObjectData) {
			var ThisActive = state.draggable.filter(item => item.index == ObjectData.index)[0];
			for(var i = 0; i < ThisActive.ConnectPoint.length; i++) {
				if((ThisActive.ConnectPoint[i].x != 0 && ThisActive.rotateDeg != 90) || (ThisActive.ConnectPoint[i].y != 0 && ThisActive.rotateDeg == 90)) {
					var aroundX = ObjectData.width - ThisActive.width;
					var aroundY = ObjectData.height - ThisActive.height;
					ThisActive.ConnectPoint[i].x += aroundX;
					ThisActive.ConnectPoint[i].y += aroundY;
				}
			}
		},
		//连接点测试
		ConnectionPointTest(state, ObjectData) {
			var ThisActive = state.draggable.filter(item => item.index == ObjectData.index)[0];
			ThisActive.ConnectPoint[2].x = ObjectData.x - ThisActive.x;
			ThisActive.ConnectPoint[2].y = ObjectData.y - ThisActive.y;
		},

		//连接点更新 百分比
		/*
		 * ConnectionPointUpdata(state, ObjectData) {
			for(var a = 0; a < state.draggable.length; a++) {
				if(ObjectData.index == state.draggable[a].index) {
					for(var i = 0; i < state.draggable[a].ConnectPoint.length; i++) {
						var OldPointPercentageX = state.draggable[a].ConnectPoint[i].x / state.draggable[a].width;
						var OldPointPercentageY = state.draggable[a].ConnectPoint[i].y / state.draggable[a].height;
						state.draggable[a].ConnectPoint[i].x = Math.round(ObjectData.width * OldPointPercentageX);
						state.draggable[a].ConnectPoint[i].y = Math.round(ObjectData.height * OldPointPercentageY);
					}
				}
			}
		},
		 */

		//显示隐藏连接点
		ConnectPointMarkModify(state, ObjectData) {
			var ThisActive = state.draggable.filter(item => item.index == ObjectData)[0];
			var OtherDraggable = state.draggable.filter(item => item.index != state.draggable[a].index && item.ShowActive);

			for(var i = 0; i < OtherDraggable.length; i++) {
				if(OtherDraggable[i].rotateDeg != 0 && ThisActive.rotateDeg != 0) {

					var NewPointOther = this.getters['defaultImgOptions/calculateRotate']({
						x: OtherDraggable[i].width,
						y: 0
					}, OtherDraggable[i].rotateDeg, OtherDraggable[i].width);
					var NewPointOtherX = parseInt(NewPointOther.x + OtherDraggable[i].x);
					var NewPointOtherY = parseInt(NewPointOther.y + OtherDraggable[i].y);

					var NewPointThis = this.getters['defaultImgOptions/calculateRotate']({
						x: ThisActive.width,
						y: 0
					}, ThisActive.rotateDeg, ThisActive.width)
					var NewPointThisX = parseInt(NewPointThis.x + ThisActive.x);
					var NewPointThisY = parseInt(NewPointThis.y + ThisActive.y);
					var JudgingMark;

					if(OtherDraggable[i].rotateDeg == 30 && ThisActive.rotateDeg == 30) {
						JudgingMark = (OtherDraggable[i].x - NewPointThisX) < state.ConnectPointMargin && (ThisActive.y - NewPointOtherY) < state.ConnectPointMargin && (OtherDraggable[i].y - NewPointThisY) < state.ConnectPointMargin && (ThisActive.x - NewPointOtherX) < state.ConnectPointMargin;
					} else if(OtherDraggable[i].rotateDeg == 30 && ThisActive.rotateDeg == -30) {
						JudgingMark = (OtherDraggable[i].x - NewPointThisX) < state.ConnectPointMargin && (NewPointThisY - NewPointOtherY) < state.ConnectPointMargin && (OtherDraggable[i].y - ThisActive.y) < state.ConnectPointMargin && (ThisActive.x - NewPointOtherX) < state.ConnectPointMargin;
					} else if(OtherDraggable[i].rotateDeg == -30 && ThisActive.rotateDeg == 30) {
						JudgingMark = (OtherDraggable[i].x - NewPointThisX) < state.ConnectPointMargin && (ThisActive.y - OtherDraggable[i].y) < state.ConnectPointMargin && (NewPointOtherY - NewPointThisY) < state.ConnectPointMargin && (ThisActive.x - NewPointOtherX) < state.ConnectPointMargin;
					} else if(OtherDraggable[i].rotateDeg == -30 && ThisActive.rotateDeg == -30) {
						JudgingMark = (OtherDraggable[i].x - NewPointThisX) < state.ConnectPointMargin && (NewPointThisY - OtherDraggable[i].y) < state.ConnectPointMargin && (NewPointOtherY - ThisActive.y) < state.ConnectPointMargin && (ThisActive.x - NewPointOtherX) < state.ConnectPointMargin;
					}

				} else if(OtherDraggable[i].rotateDeg != 0 && ThisActive.rotateDeg == 0) {

					var NewPoint = this.getters['defaultImgOptions/calculateRotate']({
						x: OtherDraggable[i].width,
						y: 0
					}, OtherDraggable[i].rotateDeg, OtherDraggable[i].width)
					var NewPointX = parseInt(NewPoint.x + OtherDraggable[i].x);
					var NewPointY = parseInt(NewPoint.y + OtherDraggable[i].y);
					var JudgingMark;
					if(OtherDraggable[i].rotateDeg == 30) {
						JudgingMark = (OtherDraggable[i].x - ThisActive.x) < (ThisActive.width + state.ConnectPointMargin) && (ThisActive.y - NewPointY) < state.ConnectPointMargin && (OtherDraggable[i].y - ThisActive.y) < (ThisActive.height + state.ConnectPointMargin) && (ThisActive.x - NewPointX) < state.ConnectPointMargin;
					} else if(OtherDraggable[i].rotateDeg == -30) {
						JudgingMark = (OtherDraggable[i].x - ThisActive.x) < (ThisActive.width + state.ConnectPointMargin) && (ThisActive.y - OtherDraggable[i].y) < state.ConnectPointMargin && (NewPointY - ThisActive.y) < (ThisActive.height + state.ConnectPointMargin) && (ThisActive.x - NewPointX) < state.ConnectPointMargin;
					}

				} else if(ThisActive.rotateDeg != 0 && OtherDraggable[i].rotateDeg == 0) {

					var NewPoint = this.getters['defaultImgOptions/calculateRotate']({
						x: ThisActive.width,
						y: 0
					}, ThisActive.rotateDeg, ThisActive.width)
					var NewPointX = parseInt(NewPoint.x + ThisActive.x);
					var NewPointY = parseInt(NewPoint.y + ThisActive.y);
					var JudgingMark;
					if(ThisActive.rotateDeg == 30) {
						JudgingMark = (OtherDraggable[i].x - ThisActive.x) < (NewPointX - ThisActive.x + state.ConnectPointMargin) && (ThisActive.y - OtherDraggable[i].y) < (OtherDraggable[i].height + state.ConnectPointMargin) && (OtherDraggable[i].y - ThisActive.y) < (NewPointY - ThisActive.y + state.ConnectPointMargin) && (ThisActive.x - OtherDraggable[i].x) < (OtherDraggable[i].width + state.ConnectPointMargin);
					} else if(ThisActive.rotateDeg == -30) {
						JudgingMark = (OtherDraggable[i].x - ThisActive.x) < (NewPointX - ThisActive.x + state.ConnectPointMargin) && (NewPointY - OtherDraggable.y) < (OtherDraggable.height + state.ConnectPointMargin) && (OtherDraggable.y - ThisActive.y) < state.ConnectPointMargin && (ThisActive.x - OtherDraggable.x) < (OtherDraggable.width + state.ConnectPointMargin);

					}

				} else {

					var JudgingMark;
					JudgingMark = (OtherDraggable[i].x - ThisActive.x) < (ThisActive.width + state.ConnectPointMargin) && (ThisActive.y - OtherDraggable[i].y) < (OtherDraggable[i].height + state.ConnectPointMargin) && (OtherDraggable[i].y - ThisActive.y) < (ThisActive.height + state.ConnectPointMargin) && (ThisActive.x - OtherDraggable[i].x) < (OtherDraggable[i].width + state.ConnectPointMargin);
				}
				if(JudgingMark) {
					OtherDraggable[i].ConnectMark = true;
					for(var x = 0; x < OtherDraggable[i].ConnectPoint.length; x++) {
						if(ThisActive.type == OtherDraggable[i].ConnectPoint[x].type) {
							OtherDraggable[i].ConnectPoint[x].Mark = true;
						} else {
							OtherDraggable[i].ConnectPoint[x].Mark = false;
						}
					}
					for(var q = 0; q < ThisActive.ConnectPoint.length; q++) {
						if(OtherDraggable[i].type == ThisActive.ConnectPoint[q].type) {
							//									ThisActive.ConnectMark = true;
							ThisActive.ConnectPoint[q].Mark = true;
						}
					}
				} else {
					OtherDraggable[i].ConnectMark = false;
					for(var x = 0; x < OtherDraggable[i].ConnectPoint.length; x++) {
						OtherDraggable[i].ConnectPoint[x].Mark = false;
					}
					for(var q = 0; q < ThisActive.ConnectPoint.length; q++) {
						//如果同类型设备在近处 而另一个同类型设备在远处 则判断远设备类型并把当前选中设备的ConnectPoint.type等于远设备类型赋值为False，会把当前已判断过的近处同类型设备的ThisActive.ConnectPoint.Mark=true覆盖成false
						if(i >= 1) {
							for(var v = 0; v < i; v++) {
								if(OtherDraggable[v].type == OtherDraggable[i].type) {
									if(!ThisActive.ConnectPoint[q].Mark) {
										if(OtherDraggable[i].type == ThisActive.ConnectPoint[q].type) {
											//													ThisActive.ConnectMark = false;
											ThisActive.ConnectPoint[q].Mark = false;
										}
									}
								}
							}
						} else {
							//									ThisActive.ConnectMark = false;
							ThisActive.ConnectPoint[q].Mark = false;
						}
					}
				}
				for(var z = 0; z < state.draggable.length; z++) {
					if(OtherDraggable[i].index == state.draggable[z].index) {
						state.draggable[z].ConnectMark = OtherDraggable[i].ConnectMark;
						for(var m = 0; m < state.draggable[z].ConnectPoint.length; m++) {
							state.draggable[z].ConnectPoint[m].Mark = OtherDraggable[i].ConnectPoint[m].Mark;
						}
					} else if(ThisActive.index == state.draggable[z].index) {
						for(var m = 0; m < state.draggable[z].ConnectPoint.length; m++) {
							state.draggable[z].ConnectPoint[m].Mark = ThisActive.ConnectPoint[m].Mark;
						}
					}
				}
			}
		},

		//重新加载连接点
		AgainLodingConnectPoint(state, ObjectData) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			var OtherDraggable = state.draggable.filter(item => item.index != state.currentIndex && item.ShowActive);
			for(var i = 0; i < ThisActive.ConnectPoint.length; i++) {
				for(var a = 0; a < OtherDraggable.length; a++) {

					if(ThisActive.ConnectPoint[i].type == OtherDraggable[a].type) {
						//						OtherDraggable[t].ConnectMark = true;
						//						ThisActive.ConnectMark = true;
						//						ThisActive.ConnectPoint[i].Mark = true;
						for(var n = 0; n < OtherDraggable[a].ConnectPoint.length; n++) {
							if(ThisActive.type == OtherDraggable[a].ConnectPoint[n].type) {
								//								OtherDraggable[t].ConnectPoint[n].Mark = true;
								var GoMark = false;
								if(ThisActive.rotateDeg == -30 && OtherDraggable[a].rotateDeg == 30) {
									/* ThisActive：-30, OtherDraggable：30 开始 */
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 6 || ThisActive.NearNum == 7 || ThisActive.NearNum == 18) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 6 || OtherDraggable[a].FarNum == 7 || OtherDraggable[a].FarNum == 18) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 1 || ThisActive.FarNum == 4 || ThisActive.FarNum == 18) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 1 || OtherDraggable[a].FarNum == 4 || OtherDraggable[a].FarNum == 18) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 0 || ThisActive.NearNum == 7 || ThisActive.NearNum == 9) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 0 || OtherDraggable[a].NearNum == 7 || OtherDraggable[a].NearNum == 9) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 1 || ThisActive.FarNum == 8 || ThisActive.FarNum == 9) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 1 || OtherDraggable[a].NearNum == 8 || OtherDraggable[a].NearNum == 9) {
												GoMark = true;
											}
										}
									}
									/* ThisActive：-30, OtherDraggable：30 结束 */

								} else if(ThisActive.rotateDeg == 30 && OtherDraggable[a].rotateDeg == -30) {
									/* ThisActive：30, OtherDraggable：-30 开始 */
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 6 || ThisActive.FarNum == 7 || ThisActive.FarNum == 18) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 6 || OtherDraggable[a].NearNum == 7 || OtherDraggable[a].NearNum == 18) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 0 || ThisActive.NearNum == 7 || ThisActive.NearNum == 9) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 0 || OtherDraggable[a].NearNum == 7 || OtherDraggable[a].NearNum == 9) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 1 || ThisActive.FarNum == 4 || ThisActive.FarNum == 18) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 1 || OtherDraggable[a].FarNum == 4 || OtherDraggable[a].FarNum == 18) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 1 || ThisActive.NearNum == 8 || ThisActive.NearNum == 9) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 1 || OtherDraggable[a].FarNum == 8 || OtherDraggable[a].FarNum == 9) {
												GoMark = true;
											}
										}
									}
									/* ThisActive：30, OtherDraggable：-30 结束 */

								} else if(ThisActive.rotateDeg == 30 && OtherDraggable[a].rotateDeg == 90) {
									/* ThisActive：30, OtherDraggable：90 开始 */
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 14 || ThisActive.NearNum == 21 || ThisActive.NearNum == 22) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 14 || OtherDraggable[a].FarNum == 21 || OtherDraggable[a].FarNum == 22) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 12 || ThisActive.FarNum == 21 || ThisActive.FarNum == 19) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 12 || OtherDraggable[a].FarNum == 21 || OtherDraggable[a].FarNum == 19) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 10 || ThisActive.FarNum == 12 || ThisActive.FarNum == 20) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 10 || OtherDraggable[a].NearNum == 12 || OtherDraggable[a].NearNum == 20) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 14 || ThisActive.NearNum == 23 || ThisActive.NearNum == 20) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 14 || OtherDraggable[a].NearNum == 23 || OtherDraggable[a].NearNum == 20) {
												GoMark = true;
											}
										}
									}
									/* ThisActive：30, OtherDraggable：90 结束 */

								} else if(ThisActive.rotateDeg == 90 && OtherDraggable[a].rotateDeg == 30) {
									/* ThisActive：90, OtherDraggable：30 开始 */
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 10 || ThisActive.NearNum == 12 || ThisActive.NearNum == 20) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 10 || OtherDraggable[a].FarNum == 12 || OtherDraggable[a].FarNum == 20) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 12 || ThisActive.FarNum == 21 || ThisActive.FarNum == 19) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 12 || OtherDraggable[a].FarNum == 21 || OtherDraggable[a].FarNum == 19) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 14 || ThisActive.FarNum == 21 || ThisActive.FarNum == 22) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 14 || OtherDraggable[a].NearNum == 21 || OtherDraggable[a].NearNum == 22) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 14 || ThisActive.NearNum == 23 || ThisActive.NearNum == 20) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 14 || OtherDraggable[a].NearNum == 23 || OtherDraggable[a].NearNum == 20) {
												GoMark = true;
											}
										}
									}
									/* ThisActive：90, OtherDraggable：30 结束 */

								} else if(ThisActive.rotateDeg == -30 && OtherDraggable[a].rotateDeg == 90) {
									/* ThisActive：-30, OtherDraggable：90 开始 */
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 2 || ThisActive.FarNum == 5 || ThisActive.FarNum == 13) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 2 || OtherDraggable[a].FarNum == 5 || OtherDraggable[a].FarNum == 13) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 3 || ThisActive.NearNum == 5 || ThisActive.NearNum == 11) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 3 || OtherDraggable[a].FarNum == 5 || OtherDraggable[a].FarNum == 11) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 16 || ThisActive.NearNum == 17 || ThisActive.NearNum == 11) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 16 || OtherDraggable[a].NearNum == 17 || OtherDraggable[a].NearNum == 11) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 15 || ThisActive.FarNum == 17 || ThisActive.FarNum == 13) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 15 || OtherDraggable[a].NearNum == 17 || OtherDraggable[a].NearNum == 13) {
												GoMark = true;
											}
										}
									}
									/* ThisActive：-30, OtherDraggable：90 结束 */

								} else if(ThisActive.rotateDeg == 90 && OtherDraggable[a].rotateDeg == -30) {
									/* ThisActive：90, OtherDraggable：-30 开始 */
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 16 || ThisActive.NearNum == 17 || ThisActive.NearNum == 11) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 16 || OtherDraggable[a].NearNum == 17 || OtherDraggable[a].NearNum == 11) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 3 || ThisActive.FarNum == 5 || ThisActive.FarNum == 11) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 3 || OtherDraggable[a].NearNum == 5 || OtherDraggable[a].NearNum == 11) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 2 || ThisActive.FarNum == 5 || ThisActive.FarNum == 13) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 2 || OtherDraggable[a].FarNum == 5 || OtherDraggable[a].FarNum == 13) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 15 || ThisActive.NearNum == 17 || ThisActive.NearNum == 13) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 15 || OtherDraggable[a].FarNum == 17 || OtherDraggable[a].FarNum == 13) {
												GoMark = true;
											}
										}
									}
									/* ThisActive：90, OtherDraggable：-30 结束 */

								} else if(ThisActive.rotateDeg == 0 && OtherDraggable[a].rotateDeg == 30) {
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && !OtherDraggable[a].FarEndMark) {
										GoMark = true;
									}
								} else if(ThisActive.rotateDeg == 30 && OtherDraggable[a].rotateDeg == 0) {
									if(ThisActive.ConnectPoint[i].typeObj == 'left' && !ThisActive.FarEndMark) {
										GoMark = true;
									}
								} else if(ThisActive.rotateDeg == 0 && OtherDraggable[a].rotateDeg == -30) {
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && !OtherDraggable[a].NearEndMark) {
										GoMark = true;
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && !OtherDraggable[a].FarEndMark) {
										GoMark = true;
									}
								} else if(ThisActive.rotateDeg == -30 && OtherDraggable[a].rotateDeg == 0) {
									if(ThisActive.ConnectPoint[i].typeObj == 'left' && !ThisActive.NearEndMark) {
										GoMark = true;
									} else if(ThisActive.ConnectPoint[i].typeObj == 'right' && !ThisActive.FarEndMark) {
										GoMark = true;
									}
								} else if(ThisActive.rotateDeg == 0 && OtherDraggable[a].rotateDeg == 90) {
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && !OtherDraggable[a].NearEndMark) {
										GoMark = true;
									}
								} else if(ThisActive.rotateDeg == 90 && OtherDraggable[a].rotateDeg == 0) {
									if(ThisActive.ConnectPoint[i].typeObj == 'right' && !ThisActive.NearEndMark) {
										GoMark = true;
									}
								}

								if(GoMark) {

									OtherDraggable[a].ConnectMark = true;
									ThisActive.ConnectMark = true;
									ThisActive.ConnectPoint[i].Mark = true;
									OtherDraggable[a].ConnectPoint[n].Mark = true;
								}

							} else {
								OtherDraggable[a].ConnectPoint[n].Mark = false;
							}
						}
					}

				}
			}
		},

		//切换当前选中的首选的状态并显示连接点
		NowActiveModifyTrue(state, ObjectData) {
			for(var a = 0; a < state.draggable.length; a++) {
				if(state.draggable[a].index == ObjectData) {
					state.draggable[a].NowActive = true;
				} else {
					state.draggable[a].NowActive = false;
					state.draggable[a].ConnectMark = false
				}
			}
			var ThisActive = state.draggable.filter(item => item.index == ObjectData)[0];
			var OtherDraggable = state.draggable.filter(item => item.index != ObjectData && item.ShowActive);
			for(var i = 0; i < ThisActive.ConnectPoint.length; i++) {
				for(var a = 0; a < OtherDraggable.length; a++) {
					if(ThisActive.ConnectPoint[i].type == OtherDraggable[a].type) {
						//						OtherDraggable[t].ConnectMark = true;
						//						ThisActive.ConnectMark = true;
						//						ThisActive.ConnectPoint[i].Mark = true;
						for(var n = 0; n < OtherDraggable[a].ConnectPoint.length; n++) {
							if(ThisActive.type == OtherDraggable[a].ConnectPoint[n].type) {
								//								OtherDraggable[t].ConnectPoint[n].Mark = true;
								var GoMark = false;
								if(ThisActive.rotateDeg == -30 && OtherDraggable[a].rotateDeg == 30) {
									/* ThisActive：-30, OtherDraggable：30 开始 */
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 6 || ThisActive.NearNum == 7 || ThisActive.NearNum == 18) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 6 || OtherDraggable[a].FarNum == 7 || OtherDraggable[a].FarNum == 18) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 1 || ThisActive.FarNum == 4 || ThisActive.FarNum == 18) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 1 || OtherDraggable[a].FarNum == 4 || OtherDraggable[a].FarNum == 18) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 0 || ThisActive.NearNum == 7 || ThisActive.NearNum == 9) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 0 || OtherDraggable[a].NearNum == 7 || OtherDraggable[a].NearNum == 9) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 1 || ThisActive.FarNum == 8 || ThisActive.FarNum == 9) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 1 || OtherDraggable[a].NearNum == 8 || OtherDraggable[a].NearNum == 9) {
												GoMark = true;
											}
										}
									}
									/* ThisActive：-30, OtherDraggable：30 结束 */

								} else if(ThisActive.rotateDeg == -30 && OtherDraggable[a].rotateDeg == 0) {
									if(ThisActive.ConnectPoint[i].typeObj == 'left' && !ThisActive.NearEndMark) {
										GoMark = true;
									} else if(ThisActive.ConnectPoint[i].typeObj == 'right' && !ThisActive.FarEndMark) {
										GoMark = true;
									}
								} else if(ThisActive.rotateDeg == -30 && OtherDraggable[a].rotateDeg == 90) {
									/* ThisActive：-30, OtherDraggable：90 开始 */
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 2 || ThisActive.FarNum == 5 || ThisActive.FarNum == 13) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 2 || OtherDraggable[a].FarNum == 5 || OtherDraggable[a].FarNum == 13) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 3 || ThisActive.NearNum == 5 || ThisActive.NearNum == 11) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 3 || OtherDraggable[a].FarNum == 5 || OtherDraggable[a].FarNum == 11) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 16 || ThisActive.NearNum == 17 || ThisActive.NearNum == 11) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 16 || OtherDraggable[a].NearNum == 17 || OtherDraggable[a].NearNum == 11) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 15 || ThisActive.FarNum == 17 || ThisActive.FarNum == 13) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 15 || OtherDraggable[a].NearNum == 17 || OtherDraggable[a].NearNum == 13) {
												GoMark = true;
											}
										}
									}
									/* ThisActive：-30, OtherDraggable：90 结束 */

								} else if(ThisActive.rotateDeg == 30 && OtherDraggable[a].rotateDeg == -30) {
									/* ThisActive：30, OtherDraggable：-30 开始 */
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 6 || ThisActive.FarNum == 7 || ThisActive.FarNum == 18) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 6 || OtherDraggable[a].NearNum == 7 || OtherDraggable[a].NearNum == 18) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 0 || ThisActive.NearNum == 7 || ThisActive.NearNum == 9) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 0 || OtherDraggable[a].NearNum == 7 || OtherDraggable[a].NearNum == 9) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 1 || ThisActive.FarNum == 4 || ThisActive.FarNum == 18) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 1 || OtherDraggable[a].FarNum == 4 || OtherDraggable[a].FarNum == 18) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 1 || ThisActive.NearNum == 8 || ThisActive.NearNum == 9) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 1 || OtherDraggable[a].FarNum == 8 || OtherDraggable[a].FarNum == 9) {
												GoMark = true;
											}
										}
									}
									/* ThisActive：30, OtherDraggable：-30 结束 */

								} else if(ThisActive.rotateDeg == 30 && OtherDraggable[a].rotateDeg == 90) {
									/* ThisActive：30, OtherDraggable：90 开始 */
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 14 || ThisActive.NearNum == 21 || ThisActive.NearNum == 22) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 14 || OtherDraggable[a].FarNum == 21 || OtherDraggable[a].FarNum == 22) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 12 || ThisActive.FarNum == 21 || ThisActive.FarNum == 19) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 12 || OtherDraggable[a].FarNum == 21 || OtherDraggable[a].FarNum == 19) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 10 || ThisActive.FarNum == 12 || ThisActive.FarNum == 20) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 10 || OtherDraggable[a].NearNum == 12 || OtherDraggable[a].NearNum == 20) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 14 || ThisActive.NearNum == 23 || ThisActive.NearNum == 20) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 14 || OtherDraggable[a].NearNum == 23 || OtherDraggable[a].NearNum == 20) {
												GoMark = true;
											}
										}
									}
									/* ThisActive：30, OtherDraggable：90 结束 */

								} else if(ThisActive.rotateDeg == 30 && OtherDraggable[a].rotateDeg == 0) {
									if(ThisActive.ConnectPoint[i].typeObj == 'left' && !ThisActive.FarEndMark) {
										GoMark = true;
									}
								} else if(ThisActive.rotateDeg == 0 && OtherDraggable[a].rotateDeg == 30) {
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && !OtherDraggable[a].FarEndMark) {
										GoMark = true;
									}
								} else if(ThisActive.rotateDeg == 0 && OtherDraggable[a].rotateDeg == -30) {
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && !OtherDraggable[a].NearEndMark) {
										GoMark = true;
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && !OtherDraggable[a].FarEndMark) {
										GoMark = true;
									}
								} else if(ThisActive.rotateDeg == 0 && OtherDraggable[a].rotateDeg == 90) {
									if(!OtherDraggable[a].NearEndMark) {
										GoMark = true;
									}if(!OtherDraggable[a].FarEndMark) {
										GoMark = true;
									}
								} else if(ThisActive.rotateDeg == 90 && OtherDraggable[a].rotateDeg == 30) {
									/* ThisActive：90, OtherDraggable：30 开始 */
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 10 || ThisActive.NearNum == 12 || ThisActive.NearNum == 20) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 10 || OtherDraggable[a].FarNum == 12 || OtherDraggable[a].FarNum == 20) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 12 || ThisActive.FarNum == 21 || ThisActive.FarNum == 19) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 12 || OtherDraggable[a].FarNum == 21 || OtherDraggable[a].FarNum == 19) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 14 || ThisActive.FarNum == 21 || ThisActive.FarNum == 22) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 14 || OtherDraggable[a].NearNum == 21 || OtherDraggable[a].NearNum == 22) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 14 || ThisActive.NearNum == 23 || ThisActive.NearNum == 20) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 14 || OtherDraggable[a].NearNum == 23 || OtherDraggable[a].NearNum == 20) {
												GoMark = true;
											}
										}
									}
									/* ThisActive：90, OtherDraggable：30 结束 */

								} else if(ThisActive.rotateDeg == 90 && OtherDraggable[a].rotateDeg == -30) {
									/* ThisActive：90, OtherDraggable：-30 开始 */
									if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 16 || ThisActive.NearNum == 17 || ThisActive.NearNum == 11) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 16 || OtherDraggable[a].NearNum == 17 || OtherDraggable[a].NearNum == 11) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'left' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].NearEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].NearEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 3 || ThisActive.FarNum == 5 || ThisActive.FarNum == 11||ThisActive.FarNum==31||ThisActive.FarNum==25||ThisActive.FarNum==24||ThisActive.FarNum==28||ThisActive.FarNum==30) {
												GoMark = true;
											}
											if(OtherDraggable[a].NearNum == 3 || OtherDraggable[a].NearNum == 5 || OtherDraggable[a].NearNum == 11) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'left') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.FarEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.FarEndMark)) {
											if(ThisActive.FarNum == 2 || ThisActive.FarNum == 5 || ThisActive.FarNum == 13) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 2 || OtherDraggable[a].FarNum == 5 || OtherDraggable[a].FarNum == 13) {
												GoMark = true;
											}
										}
									} else if(OtherDraggable[a].ConnectPoint[n].typeObj == 'right' && ThisActive.ConnectPoint[i].typeObj == 'right') {
										if((OtherDraggable[a].FarEndMark && !ThisActive.NearEndMark) || (!OtherDraggable[a].FarEndMark && ThisActive.NearEndMark)) {
											if(ThisActive.NearNum == 15 || ThisActive.NearNum == 17 || ThisActive.NearNum == 13) {
												GoMark = true;
											}
											if(OtherDraggable[a].FarNum == 15 || OtherDraggable[a].FarNum == 17 || OtherDraggable[a].FarNum == 13) {
												GoMark = true;
											}
										}
									}
									/* ThisActive：90, OtherDraggable：-30 结束 */

								} else if(ThisActive.rotateDeg == 90 && OtherDraggable[a].rotateDeg == 0) {
									if(!ThisActive.NearEndMark) {
										GoMark = true;
									}if(!ThisActive.NearEndMark) {
										GoMark = true;
									}
								}

								if(GoMark) {

									OtherDraggable[a].ConnectMark = true;
									ThisActive.ConnectMark = true;
									ThisActive.ConnectPoint[i].Mark = true;
									OtherDraggable[a].ConnectPoint[n].Mark = true;
								}

							} else if(OtherDraggable[a].type=='img'&&(ThisActive.id==10||ThisActive.id==11)){
                  OtherDraggable[a].ConnectPoint[n].Mark = true
                   OtherDraggable[a].ConnectMark = true
              } else {
                  OtherDraggable[a].ConnectPoint[n].Mark = false;
							}
						}
					}

				}
			}
		},

		//切换当前选中的首选的状态
		NowActiveModifyFalse(state, ObjectData) {
			for(var a = 0; a < state.draggable.length; a++) {
				state.draggable[a].NowActive = false;
				state.draggable[a].ConnectMark = false
			}
		},

		//隐藏所有连接点
		HiddenConnectPoint(state, obj) {
			for(let drag of state.draggable) {
				drag.ConnectMark = false;
				for(let son of drag.ConnectPoint) {
					son.Mark = false
				}
			}
		},

		//修改当前画布中缩放等级
		scaleLevelModify(state, ObjectData) {
			state.scaleLevel = ObjectData;
		},
    // 修改地图背景配置
    MapBgUpdata(state, ObjectData){
      console.log(ObjectData)
      state.MapBgData = ObjectData;
    },
		//修改当前索引
		currentIndexModify(state, index) {
			state.currentIndex = index;
		},

		//修改当前画布中元素的width,height及x,y
		CurrentPosition(state, data) {
			var ThisActive = state.draggable.filter(item => item.index == data.index)[0];
			if(data.Change == 'positionWidth') { //调整大小时
				ThisActive.width = data.width; //修改当前修改的width
				ThisActive.height = data.height; //修改当前修改的height
			} else if(data.Change == 'positionCount') { //移动元素时
				//				console.log(daselInfoSyncFalseta.centerPointX,data.centerPointY)
				ThisActive.centerPointX = data.centerPointX;
				ThisActive.centerPointY = data.centerPointY;
				ThisActive.x = data.x; //修改当前移动的x
				ThisActive.y = data.y; //修改当前移动的y
			} else if(data.Change == 'scaleChange') { //调整大小时
				ThisActive.scaleX = data.scaleX; //修改当前的scaleX
				ThisActive.scaleY = data.scaleY; //修改当前的scaleY
			}
		},

		//元素新增
		draggableBasicAdd(state, Object) {
			//
			for(var a = 0; a < state.defaultBasicConfig.length; a++) {
				if(state.defaultBasicConfig[a].id == Object.NameId) {
					for(var i = 0; i < state.defaultBasicConfig[a].content.length; i++) {
						if(state.defaultBasicConfig[a].content[i].id == Object.ContentId) {
							var ObjectData = {};
							ObjectData = JSON.parse(JSON.stringify(state.defaultBasicConfig[a].content[i]))
							ObjectData.index = state.index;
							ObjectData.centerPointX = Object.centerPointX;
							ObjectData.centerPointY = Object.centerPointY;
							ObjectData.x = Object.x;
							ObjectData.y = Object.y;
							ObjectData.showSpanName = true;
							ObjectData.active = true;
							//							console.log(ObjectData.x,ObjectData.y)
							state.draggable.push(ObjectData)
							state.currentIndex = ObjectData.index;
							state.index++;
						}
					}
				}

			}
		},
		draggableDeviceAdd(state, Object) {
			//
			for(var a = 0; a < state.defaultDeviceConfig.length; a++) {
				if(state.defaultDeviceConfig[a].id == Object.NameId) {
					for(var i = 0; i < state.defaultDeviceConfig[a].content.length; i++) {
						if(state.defaultDeviceConfig[a].content[i].id == Object.ContentId) {
							var ObjectData = {};
							ObjectData = JSON.parse(JSON.stringify(state.defaultDeviceConfig[a].content[i]))
							ObjectData.index = state.index;
							ObjectData.centerPointX = Object.centerPointX;
							ObjectData.centerPointY = Object.centerPointY;
							ObjectData.x = Object.x;
							ObjectData.y = Object.y;
							ObjectData.showSpanName = true;
							ObjectData.active = true;
							//							console.log(ObjectData.x,ObjectData.y)
							state.draggable.push(ObjectData)
							state.currentIndex = ObjectData.index;
							state.index++;
						}
					}
				}

			}
		},
		//修改当前画布内元素属性
		draggableModify(state, ObjectData) {
			// console.log(ObjectData);
		},

		//修改当前画布中元素的active状态
		ActiveForDraggable(state, ObjectData) {
			var ThisActive = state.draggable.filter(item => item.index == ObjectData.index)[0];
			if(ObjectData.Mark) {
				if(ThisActive.active && state.sync) {
					ThisActive.active = false
				} else {
					ThisActive.active = true;
				}
			} else {
				ThisActive.active = false;
			}
		},

		//将当前画布所有元素选中状态取消
		ActiveForDraggableAllFalse(state, ObjectData) {
			for(var a = 0; a < state.draggable.length; a++) {
				state.draggable[a].active = false;
			}
		},
		//剪切粘贴
		CopyDelForDraggable(state, arr) {
			for(let drag of state.draggable) {
				drag.active = false;
				drag.NowActive = false;
			}
			for(let copy of arr[0]) {
				var ObjectData = {};
				ObjectData = JSON.parse(JSON.stringify(copy))
				ObjectData.x += 15 * arr[1];
				ObjectData.y += 15 * arr[1];
				ObjectData.centerPointX += 15 * arr[1];
				ObjectData.centerPointY += 15 * arr[1];
				ObjectData.NowActive = false;
				ObjectData.active = true;
				ObjectData.ShowActive = true;
				ObjectData.id = copy.id;
				ObjectData.index = state.index;
				state.draggable.push(ObjectData);
				state.index++;
			}
		},

		ShowActiveUpdata(state, index) {
			var ThisActive = state.draggable.filter(item => item.index == index)[0];
			ThisActive.ShowActive = false;
		},

		//删除
		DelForDraggable(state, ObjectData) {
			for(var a = 0; a < state.draggable.length; a++) {
				if(state.draggable[a].active) {
					state.draggable[a].NowActive = false;
					state.draggable[a].active = false;
					state.draggable[a].ShowActive = false;
				}
			}
		},

		//垂直左对齐
		VerticalAlignmentLeft(state, obj) {
			let arr = JSON.parse(JSON.stringify(state.draggable.filter(item => item.active == true)))
			let newArr = arr.sort((a, b) => a.x - b.x);
      // 改用centerPointX定位左对齐
			let minX = newArr[0].centerPointX
      console.log(newArr,minX)
			for(let a of state.draggable.filter(item => item.active == true)) {
				a.x = minX
				a.centerPointX = minX
			}
		},
		//垂直右对齐
		VerticalAlignmentRight(state, obj) {
			let arr = JSON.parse(JSON.stringify(state.draggable.filter(item => item.active == true)))
			let newArr = arr.sort((a, b) => (b.x + b.width) - (a.x + a.width));
      // 改用centerPointX定位右对齐
			let maxX = newArr[0].centerPointX + newArr[0].width;

      console.log(newArr,maxX)
			for(let a of state.draggable.filter(item => item.active == true)) {
				a.x = maxX - a.width;
				a.centerPointX = maxX - a.width;
			}
		},
		//垂直中心点对齐
		VerticalAlignmentCenter(state, obj) {
			let arr = JSON.parse(JSON.stringify(state.draggable.filter(item => item.active == true)))
			let newArr = arr.sort((a, b) => (b.x + b.width) - (a.x + a.width));
       // 改用centerPointX定位中心点对齐
			let maxX = newArr[Math.ceil((newArr.length - 1) / 2)].centerPointX + (newArr[Math.ceil((newArr.length - 1) / 2)].width / 2);

			for(let a of state.draggable.filter(item => item.active == true)) {
				a.x = maxX - (a.width / 2);
				a.centerPointX = maxX - (a.width / 2);
			}
		},
		//垂直等距分布
		VerticalAlignmentMean(state, obj) {
			/* 拿到范围内宽度最大的设备 将该设备作为模型 计算出间隔
			 * 间隔公式：(总长度 - (最大模型宽度 * 内部模型数量 ))/(总设备数-1)
			 * 总长度 => 从左到右 第一个模型的尾巴 至 最后一个模型的头部
			 * 内部模型数量 => 总长度内所包含的模型数量
			 * 差值(由于间隔是) => (最大模型宽度 - 当前模型宽度) / 2
			 * 赋值 => 当前模型y轴 = 起点y轴坐标 + ( (当前模型索引+1) * 差值 ) + (最大模型宽度 * 索引)
       * 改用centerPointY定位等距
			 * */
			let arr = JSON.parse(JSON.stringify(state.draggable.filter(item => item.active == true)))
			let newArr = arr.sort((a, b) => a.centerPointY - b.centerPointY);
      // 改用centerPointY定位等距分布
			//总长度 起点y轴坐标
			let starty = Math.ceil(newArr[0].centerPointY + newArr[0].height);

			//总长度 终点y轴坐标
			let endy = Math.ceil(newArr[newArr.length - 1].centerPointY);

			//总长度
			let Size = Math.ceil(endy - starty);

			//获取范围内宽度最大的设备
			let scopeArr = JSON.parse(JSON.stringify(newArr));
			scopeArr.shift(); //删除第一个
			scopeArr.pop(); //删除最后一个
   //    let clacArr = scopeArr.sort((a, b) => a.height - b.height); //height从小到大排序
			// let mayModel = clacArr[clacArr.length - 1];
      let heightCount = 0
      for(let item of scopeArr){
        heightCount = heightCount+item.height
      }
			scopeArr = scopeArr.sort((a, b) => a.centerPointY - b.centerPointY); //y坐标从小到大排序
			//计算间隔
			let interval = (Size - heightCount) / (arr.length - 1);
      // debugger
      let height = 0
			//赋值
			for(let i = 0; i < scopeArr.length; i++) {
				let y = starty + ((i + 1) * interval) + height
				// let del = 0;
				// if(scopeArr[i].height != mayModel.height) {
				// 	del = (mayModel.height - scopeArr[i].height) / 2
				// }
				// scopeArr[i].y = y + del;
        scopeArr[i].y = y
        height += scopeArr[i].height
			}

			for(let a of state.draggable.filter(item => item.active == true)) {
				let arra = scopeArr.filter(item => item.index == a.index);
				if(arra.length != 0) {
					a.y = arra[0].y;
					a.centerPointY = arra[0].y;
				}
			}
		},

		//水平顶端对齐
		HorizontalAlignmentTop(state, obj) {
			let arr = JSON.parse(JSON.stringify(state.draggable.filter(item => item.active == true)))
			let newArr = arr.sort((a, b) => a.y - b.y);
      // 改用centerPointY定位顶端对齐
			let minY = newArr[0].centerPointY

			for(let a of state.draggable.filter(item => item.active == true)) {
				a.y = minY
				a.centerPointY = minY
			}
		},
		//水平底端对齐
		HorizontalAlignmentBottom(state, obj) {
			let arr = JSON.parse(JSON.stringify(state.draggable.filter(item => item.active == true)))
			let newArr = arr.sort((a, b) => (b.y + b.height) - (a.y + a.height));

      // 改用centerPointY定位顶端对齐
			let maxY = newArr[0].centerPointY + newArr[0].height;

			for(let a of state.draggable.filter(item => item.active == true)) {
				a.y = maxY - a.height;
				a.centerPointY = maxY - a.height;
			}
		},
		//水平中心点对齐
		HorizontalAlignmentCenter(state, obj) {
			let arr = JSON.parse(JSON.stringify(state.draggable.filter(item => item.active == true)))
			let newArr = arr.sort((a, b) => (b.y + b.height) - (a.y + a.height));

      // 改用centerPointY定位顶端对齐
			let maxY = newArr[Math.ceil((newArr.length - 1) / 2)].centerPointY + (newArr[Math.ceil((newArr.length - 1) / 2)].height / 2);

			for(let a of state.draggable.filter(item => item.active == true)) {
				a.y = maxY - (a.height / 2);
				a.centerPointY = maxY - (a.height / 2);
			}
		},
		//水平等距分布
		HorizontalAlignmentMean(state, obj) {
			/* 拿到范围内宽度最大的设备 将该设备作为模型 计算出间隔
			 * 间隔公式：(总长度 - (最大模型宽度 * 内部模型数量 ))/(总设备数-1)
			 * 总长度 => 从左到右 第一个模型的尾巴 至 最后一个模型的头部
			 * 内部模型数量 => 总长度内所包含的模型数量
			 * 差值(由于间隔是) => (最大模型宽度 - 当前模型宽度) / 2
			 * 赋值 => 当前模型x轴 = 起点x轴坐标 + ( (当前模型索引+1) * 差值 ) + (最大模型宽度 * 索引)
			 * */
			let arr = JSON.parse(JSON.stringify(state.draggable.filter(item => item.active == true)))
			let newArr = arr.sort((a, b) => a.x - b.x);
      // 改用centerPointX定位等距
			//总长度 起点x轴坐标
			let startx = Math.ceil(newArr[0].centerPointX + newArr[0].width);

			//总长度 终点x轴坐标
			let endx = Math.ceil(newArr[newArr.length - 1].centerPointX);

			//总长度
			let Size = Math.ceil(endx - startx);

      console.log(newArr,startx,endx,Size)
			//获取范围内宽度最大的设备
			let scopeArr = JSON.parse(JSON.stringify(newArr));
			scopeArr.shift(); //删除第一个
			scopeArr.pop(); //删除最后一个
   //    let clacArr = scopeArr.sort((a, b) => a.width - b.width); //width从小到大排序
			// let maxModel = clacArr[clacArr.length - 1];

      // 中间设备的总宽
      let widthCount = 0
      for(let item of scopeArr){
        widthCount+=item.width
      }
			scopeArr = scopeArr.sort((a, b) => a.centerPointX - b.centerPointX); //x坐标从小到大排序

			//计算间隔
			let interval = (Size - widthCount) / (arr.length - 1);
      // 已经占用的宽度
      let width = 0
			//改变中间设备节点的x值
			for(let i = 0; i < scopeArr.length; i++) {
				let x = startx + ((i + 1) * interval) + width;
				scopeArr[i].x = x;
        width += scopeArr[i].width
			}

			for(let a of state.draggable.filter(item => item.active == true)) {
				let arra = scopeArr.filter(item => item.index == a.index);
				if(arra.length != 0) {
          a.x = arra[0].x;
          a.centerPointX = arra[0].x;
          console.log(arra[0].x)
				}
			}
		},

		//斜对齐 (新版 依据角度30° 60° 来实现斜向x轴对齐
		ObliqueAlignmentX(state, index) {
			//开根号
			function sqrtOpen(m) {
				if(1 === m) return 1;
				if(0 === m) return 0;
				if(m < 0) return NaN;
				var s = m / 2;
				var last;
				while(last != s) {
					last = s;
					s = 1 / 2 * (s + m / s)
				}
				return s;
			}

			let NowActive = state.draggable.filter(item => item.index == index)[0];
			let NowActiveOthers = state.draggable.filter(item => item.active == true && item.index != index && item.ShowActive);

			if(!NowActive) {
				let minX = JSON.parse(JSON.stringify(NowActiveOthers[0]));
				for(let a of NowActiveOthers) {
					if(a.x < minX.x) {
						minX = a
					}
				}
				NowActive = JSON.parse(JSON.stringify(minX))
			}

			let NowActiveLeft = NowActiveOthers.filter(item => item.centerPointX <= NowActive.centerPointX);
			let NowActiveRight = NowActiveOthers.filter(item => item.centerPointX >= NowActive.centerPointX);
			if(NowActive.rotateDeg != 0 || NowActiveOthers.filter(item => item.rotateDeg != 0).length > 0) return;

			for(let leftDraggable of NowActiveLeft) {
				var x = Math.round(NowActive.x / sqrtOpen(3));
				var ab = x;
				var bc = 2 * x;
				var bd = ab + NowActive.y; // b点(0,bd); (x1,y1)
				var de = Math.round(bd * sqrtOpen(3)); // e点(de,0); (x2,y2)

				var distance_ab = leftDraggable.y - NowActive.y;
				var distance_ac = NowActive.x - leftDraggable.x;
				var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
				var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));
				/*
				 * 斜率公式  k = (y2 - y1) / (x2 - x1)
				 */
				/*
				 * 直线方程 (x-x1)/(x2-x1)=(y-y1)/(y2-y1)
				 */
				//var OtherDraggableSlope = ( 0 - bd) / ( de - 0);//OtherDraggable[i]斜率
				//var ThisActiveSlope = ThisActive.height / ThisActive.width;//ThisActive斜率
				/*
				 * 判断ThisActive的(x,y)是否在该直线方程上
				 */
				//				if(Math.floor(leftDraggable.x / de * 100) / 100 >= (Math.floor((leftDraggable.y - bd) / (-bd) * 100) / 100) - state.SkewAlineAmplitude && Math.floor(leftDraggable.x / de * 100) / 100 <= (Math.floor((leftDraggable.y - bd) / (-bd) * 100) / 100) + state.SkewAlineAmplitude && bd != 0) {
				//ThisActive.x = parseInt((ThisActive.y - bd) / (-bd) * de);
				var NewThisActivey = parseInt((leftDraggable.x / de * (-bd)) + bd);
				var delY = NewThisActivey - leftDraggable.y
				leftDraggable.y += delY;
				leftDraggable.centerPointY += delY;
				//				}
			}
			for(let rightDraggable of NowActiveRight) {
				var x = Math.round(NowActive.x / sqrtOpen(3));
				var ab = x;
				var bd = ab + NowActive.y; // b点(0,bd); (x1,y1)
				var de = Math.round(bd * sqrtOpen(3)); // e点(de,0); (x2,y2)

				var distance_ab = rightDraggable.y - NowActive.y;
				var distance_ac = NowActive.x - rightDraggable.x;
				var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
				var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));
				//				if(Math.floor(ThisActive.x / de * 100) / 100 >= (Math.floor((ThisActive.y - bd) / (-bd) * 100) / 100) - state.SkewAlineAmplitude && Math.floor(ThisActive.x / de * 100) / 100 <= (Math.floor((ThisActive.y - bd) / (-bd) * 100) / 100) + state.SkewAlineAmplitude && bd != 0) {
				//ThisActive.x = parseInt((ThisActive.y - bd) / (-bd) * de);
				var NewThisActivey = parseInt((rightDraggable.x / de * (-bd)) + bd);
				var delY = NewThisActivey - rightDraggable.y
				rightDraggable.y += delY;
				rightDraggable.centerPointY += delY;
				//				}
			}

		},

		//斜对齐 (新版 依据角度30° 60° 来实现斜向y轴对齐
		ObliqueAlignmentY(state, index) {
			//开根号
			function sqrtOpen(m) {
				if(1 === m) return 1;
				if(0 === m) return 0;
				if(m < 0) return NaN;
				var s = m / 2;
				var last;
				while(last != s) {
					last = s;
					s = 1 / 2 * (s + m / s)
				}
				return s;
			}

			let NowActive = state.draggable.filter(item => item.index == index)[0];
			let NowActiveOthers = state.draggable.filter(item => item.active == true && item.index != index && item.ShowActive);

			if(!NowActive) {
				let minY = JSON.parse(JSON.stringify(NowActiveOthers[0]));
				for(let a of NowActiveOthers) {
					if(a.y < minY.y) {
						minY = a
					}
				}
				NowActive = JSON.parse(JSON.stringify(minY))
			}

			let NowActiveLeft = NowActiveOthers.filter(item => item.centerPointY <= NowActive.centerPointY);
			let NowActiveRight = NowActiveOthers.filter(item => item.centerPointY >= NowActive.centerPointY);
			if(NowActive.rotateDeg != 0 || NowActiveOthers.filter(item => item.rotateDeg != 0).length > 0) return;

			for(let leftDraggable of NowActiveLeft) {
				var x = NowActive.y;
				var ef = Math.round(x * sqrtOpen(3));
				var ePoint = -(ef - (NowActive.x + NowActive.width))
				// e点(ePoint,0); (x1,y1)
				// c点(NowActive.x+NowActive.width, NowActive.y); (x2,y2)

				var distance_ab = leftDraggable.y - NowActive.y;
				var distance_ac = (leftDraggable.x + leftDraggable.width) - (NowActive.x + NowActive.width);
				var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
				var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));

				var vm_x = leftDraggable.x + leftDraggable.width;
				var vm_x1 = ePoint;
				var vm_x2 = NowActive.x + NowActive.width;
				var vm_y = leftDraggable.y;
				var vm_y1 = 0;
				var vm_y2 = NowActive.y;
				//				if(Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 >= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) - state.SkewAlineAmplitude && Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 <= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) + state.SkewAlineAmplitude && vm_y2 != 0) {
				//ThisActive.x = parseInt((((ThisActive.y-0)*(NowActive.x+NowActive.width-ePoint))/(NowActive.y-0))+ePoint ) - ThisActive.width
				var NewThisActivey = parseInt(((vm_x - vm_x1) * (vm_y2 - vm_y1)) / (vm_x2 - vm_x1))
				var delY = NewThisActivey - leftDraggable.y
				leftDraggable.y += delY;
				leftDraggable.centerPointY += delY;
				//				}
			}
			for(let rightDraggable of NowActiveRight) {
				var x = NowActive.y;
				var ef = Math.round(x * sqrtOpen(3));
				var ePoint = -(ef - (NowActive.x + NowActive.width))
				// e点(ePoint,0); (x1,y1)
				// c点(NowActive.x+NowActive.width, NowActive.y); (x2,y2)

				var distance_ab = rightDraggable.y - NowActive.y;
				var distance_ac = (rightDraggable.x + rightDraggable.width) - (NowActive.x + NowActive.width);
				var distance_cbTwoPower = Math.pow(distance_ab, 2) + Math.pow(distance_ac, 2);
				var distance_cb = parseInt(Math.sqrt(distance_cbTwoPower));

				var vm_x = rightDraggable.x + rightDraggable.width;
				var vm_x1 = ePoint;
				var vm_x2 = NowActive.x + NowActive.width;
				var vm_y = rightDraggable.y;
				var vm_y1 = 0;
				var vm_y2 = NowActive.y;
				//				if(Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 >= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) - state.SkewAlineAmplitude && Math.floor((vm_x - vm_x1) / (vm_x2 - vm_x1) * 100) / 100 <= (Math.floor((vm_y - vm_y1) / (vm_y2 - vm_y1) * 100) / 100) + state.SkewAlineAmplitude && vm_y2 != 0) {
				//ThisActive.x = parseInt((((ThisActive.y-0)*(NowActive.x+NowActive.width-ePoint))/(NowActive.y-0))+ePoint) - ThisActive.width
				var NewThisActivey = parseInt(((vm_x - vm_x1) * (vm_y2 - vm_y1)) / (vm_x2 - vm_x1))
				var delY = NewThisActivey - rightDraggable.y
				rightDraggable.y += delY;
				rightDraggable.centerPointY += delY;
				//				}
			}
		},

		//斜对齐 (旧版 依据amplitude的值来定义斜对齐间距
		ObliqueAlignmentOld(state, index) {
			const NowActive = state.draggable.filter(item => item.index == index)[0];
			const NowActiveOthers = state.draggable.filter(item => item.active == true && item.index != index && item.ShowActive);
			const NowActiveLeft = NowActiveOthers.filter(item => item.centerPointX <= NowActive.centerPointX);
			const NowActiveRight = NowActiveOthers.filter(item => item.centerPointX >= NowActive.centerPointX);
			if(NowActive.rotateDeg != 0 || NowActiveOthers.filter(item => item.rotateDeg != 0).length > 0) return;

			for(var i = 0; i < NowActiveLeft.length; i++) {
				var maxStr;
				for(var j = i; j < NowActiveLeft.length; j++) {
					if(NowActiveLeft[i].centerPointX < NowActiveLeft[j].centerPointX) {
						maxStr = NowActiveLeft[j];
						NowActiveLeft[j] = NowActiveLeft[i];
						NowActiveLeft[i] = maxStr;
					}
				};
			}; //左侧从大到小 排序

			for(var i = 0; i < NowActiveRight.length; i++) {
				var minStr;
				for(var j = i; j < NowActiveRight.length; j++) {
					if(NowActiveRight[i].centerPointX > NowActiveRight[j].centerPointX) {
						minStr = NowActiveRight[j];
						NowActiveRight[j] = NowActiveRight[i];
						NowActiveRight[i] = minStr;
					}
				};
			}; //右侧从小到大 排序

			//			关键算法
			for(var i = 0; i < NowActiveLeft.length; i++) {
				if(i == 0) {
					NowActiveLeft[i].centerPointX = NowActive.centerPointX - NowActiveLeft[i].width - state.amplitudeX;
					NowActiveLeft[i].centerPointY = NowActive.centerPointY + NowActive.height + state.amplitudeY;
				} else {
					NowActiveLeft[i].centerPointX = NowActiveLeft[i - 1].centerPointX - NowActiveLeft[i].width - state.amplitudeX;
					NowActiveLeft[i].centerPointY = NowActiveLeft[i - 1].centerPointY + NowActiveLeft[i - 1].height + state.amplitudeY;
				}
				for(var a = 0; a < state.draggable.length; a++) {
					if(NowActiveLeft[i].index == state.draggable[a].index) {
						state.draggable[a].centerPointX = NowActiveLeft[i].centerPointX;
						state.draggable[a].centerPointY = NowActiveLeft[i].centerPointY;
					}
				}
			}
			for(var i = 0; i < NowActiveRight.length; i++) {
				if(i == 0) {
					NowActiveRight[i].centerPointX = NowActive.centerPointX + NowActive.width + state.amplitudeX;
					NowActiveRight[i].centerPointY = NowActive.centerPointY - NowActiveRight[i].height - state.amplitudeY;
				} else {
					NowActiveRight[i].centerPointX = NowActiveRight[i - 1].centerPointX + NowActiveRight[i - 1].width + state.amplitudeX;
					NowActiveRight[i].centerPointY = NowActiveRight[i - 1].centerPointY - NowActiveRight[i].height - state.amplitudeY;
				}
				for(var a = 0; a < state.draggable.length; a++) {
					if(NowActiveRight[i].index == state.draggable[a].index) {
						state.draggable[a].centerPointX = NowActiveRight[i].centerPointX;
						state.draggable[a].centerPointY = NowActiveRight[i].centerPointY;
					}
				}
			}
			//			console.log(NowActiveRight)
		},

		//多选状态变更
		syncTrue(state, objectData) {
			state.sync = true;
		},
		syncFalse(state, objectData) {
			state.sync = false;
		},

		DivNameChange(state, ObjectData) {
			var ThisActive = state.draggable.filter(item => item.active);
			for(let obj of ThisActive) {
				obj.divName = ObjectData
			}
		},
		directionUpdata(state, ObjectData) {
			var ThisActive = state.draggable.filter(item => item.active);
      for(let obj of ThisActive) {
        obj.direction = ObjectData
			}
		},
		conduitColorChange(state, ObjectData) {
			var arr = state.draggable.filter(item => item.active);
			for(let ThisActive of arr) {
				ThisActive.colorId = ObjectData;
				if(ThisActive.colorId == 1) {
					if(ThisActive.rotateDeg == 90) {
						ThisActive.imagePng = require('@/assets/image/editor/gray_top_png.png')
						ThisActive.imageGif = require('@/assets/image/editor/gray_top_gif.gif')
					} else {
						ThisActive.imagePng = require('@/assets/image/editor/gray_png.png')
						ThisActive.imageGif = require('@/assets/image/editor/gray_gif.gif')
					}
				} else if(ThisActive.colorId == 2) {
					if(ThisActive.rotateDeg == 90) {
						ThisActive.imagePng = require('@/assets/image/editor/red_top_png.png')
						ThisActive.imageGif = require('@/assets/image/editor/red_top_gif.gif')
					} else {
						ThisActive.imagePng = require('@/assets/image/editor/red_png.png')
						ThisActive.imageGif = require('@/assets/image/editor/red_gif.gif')
					}
				} else if(ThisActive.colorId == 3) {
					if(ThisActive.rotateDeg == 90) {
						ThisActive.imagePng = require('@/assets/image/editor/blue_top_png.png')
						ThisActive.imageGif = require('@/assets/image/editor/blue_top_gif.gif')
					} else {
						ThisActive.imagePng = require('@/assets/image/editor/blue_png.png')
						ThisActive.imageGif = require('@/assets/image/editor/blue_gif.gif')
					}
				} else if(ThisActive.colorId == 4) {
					if(ThisActive.rotateDeg == 90) {
						ThisActive.imagePng = require('@/assets/image/editor/green_top_png.png')
						ThisActive.imageGif = require('@/assets/image/editor/green_top_gif.gif')
					} else {
						ThisActive.imagePng = require('@/assets/image/editor/green_png.png')
						ThisActive.imageGif = require('@/assets/image/editor/green_gif.gif')
					}
				} else if(ThisActive.colorId == 5) {
					if(ThisActive.rotateDeg == 90) {
						ThisActive.imagePng = require('@/assets/image/editor/org_top_png.png')
						ThisActive.imageGif = require('@/assets/image/editor/org_top_gif.gif')
					} else {
						ThisActive.imagePng = require('@/assets/image/editor/org_png.png')
						ThisActive.imageGif = require('@/assets/image/editor/org_gif.gif')
					}
				}
			}
		},
		ProductCodeUpdata(state, code) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			ThisActive.ProductCode = code;
		},
		ClearThreshold(state, obj) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			ThisActive.thresholdSymbol = '';
			ThisActive.thresholdValue = '';
			ThisActive.thresholdMark = false;
			ThisActive.ValueOptions = [];
		},
		thresholdMarkChange(state, mark) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			if(mark == 'true') {
				ThisActive.thresholdMark = true
			} else if(mark == 'false') {
				ThisActive.thresholdMark = false
			}
		},
		DeviceAttrTypeUpdata(state, obj) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			ThisActive.DeviceAttrType = obj;
		},
		ValueOptionsUpdata(state, obj) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			ThisActive.ValueOptions = obj;
		},
		NearShowClick(state, objectData) {
			if(state.ShowMarkNear) {
				state.ShowMarkNear = false;
			} else {
				state.ShowMarkFar = false;
				state.ShowMarkNear = true;
			}
		},
		FarShowClick(state, objectData) {
			if(state.ShowMarkFar) {
				state.ShowMarkFar = false;
			} else {
				state.ShowMarkNear = false;
				state.ShowMarkFar = true;
			}
		},
		NearClose(state, obj) {
			state.ShowMarkNear = false;
		},
		FarClose(state, obj) {
			state.ShowMarkFar = false;
		},
		draggableUpdata(state, objectData) {
			//mothFather
			let draggable = objectData.filter(item => item.ShowActive == true);
			//重新遍历索引index 起始值为1
			//console.log(state.mothFather)
			/*let index = 0;
			for(let a of draggable){
				a.index = index + 1;
				a.NowActive = false;
				a.active = false;
				let mothFather = state.mothFather.filter(item => (item.id == a.id)&&(a.type == 'img'));
				if(mothFather.length != 0){
					let moth = mothFather[0];
					a.ConnectPoint = [];
					a.ImgUrl = moth.image;
					var ConnectPoint = JSON.parse(moth.joinPoint);
					var propertie = JSON.parse(moth.propertie)[0];
					a.propertie = propertie;
					for(let c of ConnectPoint){
						a.
					}
				}


				index++;
			}*/
			for(var a = 0; a < draggable.length; a++) {
				draggable[a].index = a + 1;
				draggable[a].NowActive = false;
				draggable[a].active = false;
				if(draggable[a].type == 'img') {
					draggable[a].ImgUrl = '';
				}
				for(var i = 0; i < state.mothFather.length; i++) {
					if((draggable[a].id == state.mothFather[i].id) && (draggable[a].type == 'img')) {
						draggable[a].ConnectPoint = [];
						draggable[a].ImgUrl = state.mothFather[i].image;
						var ConnectPoint = JSON.parse(state.mothFather[i].joinPoint);
						var propertie = JSON.parse(state.mothFather[i].propertie)[0];
						draggable[a].propertie = propertie; /*总状态 直接赋值*/
						/*
						 hasAlarmLight 报警灯
						 hasStateLight 状态指示灯
						 hasProgressBar进度条
						 * */
						for(var c = 0; c < ConnectPoint.length; c++) {
							draggable[a].ConnectPoint[c] = {
								x: ConnectPoint[c].x,
								y: ConnectPoint[c].y,
								Mark: false,
								SkewAline: [{
									name: "LeftTop",
									Mark: false,
									width: 0, //长度
								}, {
									name: "LeftTop_vm",
									Mark: false,
									width: 0, //长度
								}, {
									name: "LeftBottom",
									Mark: false,
									width: 0, //长度
								}, {
									name: "LeftBottom_vm",
									Mark: false,
									width: 0, //长度
								}], //斜线对齐 显示参数
							};
							if(ConnectPoint[c].type == 1) {
								draggable[a].ConnectPoint[c].type = 'conduit30';
							} else if(ConnectPoint[c].type == 2) {
								draggable[a].ConnectPoint[c].type = 'conduit-30';
							} else if(ConnectPoint[c].type == 3) {
								draggable[a].ConnectPoint[c].type = 'conduit90';
							}
						}
						draggable[a].ConnectMark = false;
					}
				}
			}
			state.draggable = draggable;
			state.currentIndex = 0;
			state.index = state.draggable.length + 1;
		},
		DevicePropUpdata(state, objectData) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			ThisActive.DeviceId = objectData.DeviceId;
			ThisActive.DeviceCode = objectData.DeviceCode;
			ThisActive.DevicePropCode = objectData.DevicePropCode;
			ThisActive.DeviceName = objectData.DeviceName;
			ThisActive.DevicePropName = objectData.DevicePropName;
			ThisActive.DevicePropValue = objectData.DevicePropValue;
			ThisActive.DeviceData = objectData.DeviceData;
		},
		DeviceIdUpdata(state, obj) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			ThisActive.DeviceId = obj.DeviceID;
			ThisActive.DeviceCode = obj.DeviceCode;
			ThisActive.DeviceName = obj.DeviceName;
			ThisActive.DeviceAllAttrList = obj.DeviceAllAttrList;
			ThisActive.DeviceAttrList = obj.DeviceAttrList;
			ThisActive.DeviceAttrStateList = obj.DeviceAttrStateList;
		},
    TextShowData(state, obj){
      var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
      ThisActive.DeviceShowCode=obj.DeviceShowCode
      ThisActive.attrIdentifier = obj.attrIdentifier
      ThisActive.showAttrKey = obj.showAttrKey
      ThisActive.textShowData = obj.textShowData
    },
    TextStyleData(state, obj){
     if(obj.fontColor){
       var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
       ThisActive.fontColor=obj.fontColor
     }
     if(obj.bgColor){
       var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
       ThisActive.bgColor=obj.bgColor
     }
     if(obj.fontSize){
       var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
       ThisActive.fontSize=obj.fontSize
     }
    },
		DeviceAttrValueUpdata(state, objectData) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			ThisActive.DeviceAttrID = objectData.DeviceAttrID;
		},
		DeviceAttrStateValueUpdata(state, obj) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			ThisActive.DeviceAttrStateID = obj.DeviceAttrStateID;
		},
		DeviceAttrDataTypeUpdata(state, obj) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			for(let list of ThisActive.DeviceAttrList) {
				if(list.id == obj.code) {
					list.dataType = obj.dataType
				}
			}
		},
		DevicePropMultipleUpdata(state, objectData) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			ThisActive.DeviceMultipleArray = objectData;
		},
		DevicePropMothUpdata(state, obj) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			ThisActive.DeviceMoth = obj;
		},
		DeviceBlockArrayUpdata(state, obj) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			let arr = [];
			for(let a of obj) {
				arr.push(a[0])
			}
			ThisActive.DeviceBlockArray = arr;
			ThisActive.DeviceBlockArrayShow = obj;
		},
		DeviceLightShowUpdata(state, objectData) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			if(objectData.name == 'DeviceStateLight') {
				ThisActive.DeviceStateLightShow = objectData.val;
			} else if(objectData.name == 'DeviceAlertLight') {
				ThisActive.DeviceAlertLightShow = objectData.val;
			} else if(objectData.name == 'DeviceProgressLight') {
				ThisActive.DeviceProgressLightShow = objectData.val;
			}
		},
		showSpanNameUpdata(state, mark) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			ThisActive.showSpanName = mark;
		},
		showSpanTypeUpdata(state, mark) {
			var ThisActive = state.draggable.filter(item => item.index == state.currentIndex)[0];
			ThisActive.spanShowValue = mark;
		},
		ClickShowMarkUpdata(state, objectData) {
			var ThisActive = state.draggable.filter(item => item.index == objectData)[0];
			ThisActive.ClickShowMark = !ThisActive.ClickShowMark;
      console.log(ThisActive)
		},
		stepClear(state, obj) {
			state.step = 0;
		},
		revokeStorage(state, type) {
			state.step++;
			state.revokeDraggable.push(JSON.parse(JSON.stringify(state.draggable)))
			if(state.revokeDraggable.length > state.revokeNum) {
				//删除下标为0，长度为1的撤销状态存储数组
				state.revokeDraggable.splice(0, 1);
			}
		},
		RevokeStorageBack(state, obj) {
			if(state.revokeDraggable.length != 0) {
				//存储恢复状态
				state.recoverDraggable.push(JSON.parse(JSON.stringify(state.draggable)))
				if(state.recoverDraggable.length > state.recoverNum) {
					//删除下标为0，长度为1的恢复状态存储数组
					state.recoverDraggable.splice(0, 1);
				}

				state.draggable = JSON.parse(JSON.stringify(state.revokeDraggable[state.revokeDraggable.length - 1].filter(item => item.ShowActive == true)));
				state.revokeDraggable.splice(state.revokeDraggable.length - 1, 1) //撤回原来的状态，删除已被使用撤回的数组

				//重新遍历索引index 起始值为1
				for(var a = 0; a < state.draggable.length; a++) {
					state.draggable[a].index = a + 1;
				}
				state.index = state.draggable.length + 1;
				if(state.draggable.filter(item => item.NowActive == true).length != 0) {
					state.currentIndex = state.draggable.filter(item => item.NowActive == true)[0].index
				}
			}
		},
		revokeStorageClear(state, obj) {
			state.revokeDraggable = [];
		},
		RecoverStorageBack(state, obj) {
			if(state.recoverDraggable.length != 0) {
				state.draggable = JSON.parse(JSON.stringify(state.recoverDraggable[state.recoverDraggable.length - 1].filter(item => item.ShowActive == true)))
				state.recoverDraggable.splice(state.recoverDraggable.length - 1, 1) //恢复到撤回之前的状态，删除已被使用恢复的数组

				//重新遍历索引index 起始值为1
				for(var a = 0; a < state.draggable.length; a++) {
					state.draggable[a].index = a + 1;
				}
				state.index = state.draggable.length + 1;
				if(state.draggable.filter(item => item.NowActive == true).length != 0) {
					state.currentIndex = state.draggable.filter(item => item.NowActive == true)[0].index
				}
			}
		},
		recoverStorageClear(state, obj) {
			state.recoverDraggable = [];
		},
		DefaultConfigDeviceUpdata(state, ObjectData) {
			var configArr = []
			var DeviceList = ObjectData[0];
			state.mothFather = ObjectData[1];
			for(var a = 0; a < DeviceList.length; a++) {
				configArr[a] = {};
				configArr[a].id = DeviceList[a].id;
				configArr[a].name = DeviceList[a].name;
				configArr[a].content = [];
				for(var i = 0; i < DeviceList[a].children.length; i++) {
					configArr[a].content[i] = {};
					configArr[a].content[i].id = DeviceList[a].children[i].id;
					configArr[a].content[i].x = 0;
					configArr[a].content[i].y = 0;
					configArr[a].content[i].centerPointX = 0;
					configArr[a].content[i].centerPointY = 0;
					configArr[a].content[i].scaleX = 1;
					configArr[a].content[i].scaleY = 1;
					configArr[a].content[i].name = DeviceList[a].children[i].name;
					configArr[a].content[i].divName = DeviceList[a].children[i].name;
					configArr[a].content[i].ShowActive = true;
					configArr[a].content[i].ImgUrl = DeviceList[a].children[i].image;
					var img = new Image();
					img.src = state.ImageBaseUrl + configArr[a].content[i].ImgUrl;
					configArr[a].content[i].width = img.width;
					configArr[a].content[i].height = img.height;
					configArr[a].content[i].fixeWidth = img.width;
					configArr[a].content[i].fixeHeight = img.height;
					configArr[a].content[i].rotateDeg = 0;
					configArr[a].content[i].ConnectPoint = [];
					var ConnectPoint = JSON.parse(DeviceList[a].children[i].joinPoint);
					var propertie = JSON.parse(DeviceList[a].children[i].propertie)[0];
					configArr[a].content[i].propertie = propertie;
					/*
					 hasAlarmLight 报警灯
					 hasStateLight 状态指示灯
					 hasProgressBar进度条
					 * */
					for(var c = 0; c < ConnectPoint.length; c++) {
						configArr[a].content[i].ConnectPoint[c] = {
							x: ConnectPoint[c].x,
							y: ConnectPoint[c].y,
							Mark: false,
							SkewAline: [{
								name: "LeftTop",
								Mark: false,
								width: 0, //长度
							}, {
								name: "LeftTop_vm",
								Mark: false,
								width: 0, //长度
							}, {
								name: "LeftBottom",
								Mark: false,
								width: 0, //长度
							}, {
								name: "LeftBottom_vm",
								Mark: false,
								width: 0, //长度
							}], //斜线对齐 显示参数
						};
						if(ConnectPoint[c].type == 1) {
							configArr[a].content[i].ConnectPoint[c].type = 'conduit30';
						} else if(ConnectPoint[c].type == 2) {
							configArr[a].content[i].ConnectPoint[c].type = 'conduit-30';
						} else if(ConnectPoint[c].type == 3) {
							configArr[a].content[i].ConnectPoint[c].type = 'conduit90';
						}
					}
					configArr[a].content[i].ConnectMark = false;
					configArr[a].content[i].zIndex = 1;
					configArr[a].content[i].SkewAline = [{
						name: "LeftTop",
						Mark: false,
						width: 0, //长度
					}, {
						name: "LeftTop_vm",
						Mark: false,
						width: 0, //长度
					}, {
						name: "LeftBottom",
						Mark: false,
						width: 0, //长度
					}, {
						name: "LeftBottom_vm",
						Mark: false,
						width: 0, //长度
					}, {
						name: "RightTop",
						Mark: false,
						width: 0, //长度
					}, {
						name: "RightTop_vm",
						Mark: false,
						width: 0, //长度
					}, {
						name: "RightBottom",
						Mark: false,
						width: 0, //长度
					}, {
						name: "RightBottom_vm",
						Mark: false,
						width: 0, //长度
					}]; //斜线对齐 显示参数
					configArr[a].content[i].active = false;
					configArr[a].content[i].type = "img";
					configArr[a].content[i].typeDefault = "企业控件";
					configArr[a].content[i].NowActive = false;
					configArr[a].content[i].DeviceId = null;
					//configArr[a].content[i].DevicePropId = null;
					configArr[a].content[i].DeviceStateLightShow = false;
					configArr[a].content[i].DeviceAlertLightShow = false;
					configArr[a].content[i].DeviceProgressLightShow = false;
					configArr[a].content[i].DeviceStateLightColor = 'green';
					configArr[a].content[i].DeviceAlertLightColor = 'green';
					configArr[a].content[i].DeviceProgressLightColor = 'green';
					configArr[a].content[i].DeviceAttrID = null;
					configArr[a].content[i].DeviceAttrStateID = null;
					configArr[a].content[i].DeviceAttrList = [];
					configArr[a].content[i].DeviceAllAttrList = [];
				}
			}
			state.defaultDeviceConfig = configArr
		},
	}, //结束创建方法
}



// WEBPACK FOOTER //
// ./src/vueX/model/defaultImgOptions.js